/* =============================================================
   Astra PDP  -  ported from fableroom-pdp-template/final.html
   Wrapped in one IIFE so generic helper names (show/update/render/
   cycle/frame) never leak to window and collide with theme globals.
   Inline on* handlers are re-exposed on window at the end of init.
   Runs on DOMContentLoaded and re-runs on shopify:section:load
   (theme editor). Gallery data comes from the #astra-pdp-data JSON
   blob emitted by the section. Dropped: exit-intent + consent
   auto-triggers, site chrome (theme provides header/footer).
   Data wiring to real variants/cart happens in later phases.
   ============================================================= */
(function(){
  'use strict';
  function astra(){
    var __root=document.querySelector('.astra-pdp');
    if(!__root)return;
    /* Gallery slides/thumbs are server-rendered by Liquid (see
       sections/astra-pdp.liquid #gTrack/#gthumbs) so the hero/LCP image
       ships in the initial HTML instead of waiting on this deferred
       script to build it from #astra-pdp-data. Only wipe + rebuild from
       that JSON as a defensive fallback when the server markup is
       missing (e.g. a product with no media). */
    var __gt=document.getElementById('gTrack');
    var __th=document.getElementById('gthumbs');
    var __hasServerGallery=!!(__gt&&__gt.querySelector('.g-slide'));
    if(!__hasServerGallery){
      if(__gt)__gt.innerHTML='';
      if(__th)__th.innerHTML='';
    }

    /* ===== Phase 2: variant wiring =========================================
       Reads #astra-variants-data (emitted only for multi-variant products),
       maps a swatch's option value -> the matching (preferably available)
       variant, and updates price / compare / save% / ATC / sticky bar /
       availability, plus a best-effort gallery jump to the variant image.
       Drives the hidden input#astraVariantId (name="id") the Phase 4 form
       will submit. Single-variant products keep the mockup's static swatches. */
    var VD=(function(){var n=document.getElementById('astra-variants-data');
      try{return n?JSON.parse(n.textContent):null;}catch(e){return null;}})();
    function astraVariantByValue(val){
      if(!VD||!VD.variants)return null;
      var key='o'+(VD.optionPosition||1),match=null;
      for(var i=0;i<VD.variants.length;i++){
        if(String(VD.variants[i][key])===String(val)){
          if(!match)match=VD.variants[i];
          if(VD.variants[i].available){match=VD.variants[i];break;}
        }
      }
      return match;
    }
    function astraApplyVariant(v){
      if(!v)return;
      var onSale=v.compare&&v.compare>v.price;
      var pct=onSale?Math.round((v.compare-v.price)*100/v.compare):0;
      var idIn=document.getElementById('astraVariantId'); if(idIn)idIn.value=v.id;
      var now=document.querySelector('.astra-pdp .p-now'); if(now)now.innerHTML=v.priceStr;
      var was=document.querySelector('.astra-pdp .p-was');
      if(was){was.style.display=onSale?'':'none'; if(onSale)was.innerHTML=v.compareStr;}
      var sav=document.querySelector('.astra-pdp .p-save');
      if(sav){sav.style.display=onSale?'':'none'; if(onSale)sav.textContent=pct+'% off';}
      var atc=document.getElementById('mainAtc');
      if(atc){atc.disabled=!v.available;atc.innerHTML=v.available?('Add to Basket - '+v.priceStr):'Sold out';}
      var sbP=document.querySelector('.astra-pdp .sb-price');
      if(sbP)sbP.innerHTML=v.priceStr+(onSale?(' <s>'+v.compareStr+'</s> <span class="sb-save">-'+pct+'%</span>'):'');
      var sbBtn=document.querySelector('.astra-pdp .sb-btn');
      if(sbBtn){sbBtn.disabled=!v.available;sbBtn.textContent=v.available?'Add to Basket':'Sold out';}
      /* re-badge the gallery for this variant: its own sale %, its own
         badge.variant_badge list (v.badges also carries the product-level
         custom.product_badge values), and no badges at all when it is sold
         out - otherwise the previous variant's tags stay up */
      badgeTags=astraBuildBadgeTags(onSale,pct,v.badges,v.available);
      /* the campaign badge is a product tag, so it does not change per variant
         - but its sold-out suppression does, and dropping it here is what
         floats the metafield badges back up to the top of the image */
      saleTags=astraBuildSaleTags(v.available);
      astraResetBadges();
      /* BNPL "pay in 3" teaser on the buy box toggle - server-rendered as
         price/3 in Liquid, so re-price it here or a variant switch leaves the
         old instalment showing. Math.floor matches Liquid's integer
         `divided_by: 3` on the cents value. (The panel/modal contents are the
         vendors' own widgets - astraRefreshBnpl re-renders those.) */
      var inst=astraMoney(Math.floor(v.price/3),true);
      document.querySelectorAll('.astra-pdp [data-astra-instalment]').forEach(function(el){el.innerHTML=inst;});
      window.astraRefreshBnpl(v.id,v.price);
      /* keep the FBT "this item" row in sync with the selected variant */
      var fbtFirst=document.querySelector('.astra-pdp .fbt-items .fbt-item input');
      if(fbtFirst){fbtFirst.setAttribute('data-price',v.price);fbtFirst.setAttribute('data-variant-id',v.id);
        var fp=fbtFirst.closest('.fbt-item').querySelector('.fbt-p'); if(fp)fp.innerHTML=v.priceStr;
        if(typeof fbtCalc==='function')fbtCalc();}
      /* best-effort: jump the gallery to this variant's own image if present */
      if(v.img){var base=v.img.split('?')[0];
        var gs=document.querySelectorAll('.astra-pdp #gTrack .g-slide img');
        for(var j=0;j<gs.length;j++){if(gs[j].src.split('?')[0]===base){if(typeof show==='function')show(j);break;}}
      }
      /* refresh the delivery bar for the newly selected variant */
      var db=document.getElementById('delivBar'); if(db&&v.sku!=null)db.setAttribute('data-sku',v.sku);
      astraUpdateEDD(v.sku, v.deliveryDays);
      /* the compare rows live on the variant, so let the Astra Comparison
         section re-render itself for this variant (it also syncs the modal
         table and the "You save" pill back into this section) */
      document.dispatchEvent(new CustomEvent('astra:variant:change',{bubbles:true,detail:{variant:v}}));
    }
    function astraSelectByValue(val){astraApplyVariant(astraVariantByValue(val));}
    window.astraSelectByValue=astraSelectByValue;

    /* ===== Delivery estimate (EDD) ==========================================
       Mirrors the production PDP (main-product.liquid `delivery_estimate_days`
       block + assets/product-form.js / variant-picker.js): the delivery message
       is fetched live per SKU from the EDD API rather than baked in from the
       design mockup. Runs on load and on every variant change; hides the bar on
       API error / blank response; stashes the message so it rides along on the
       cart line item as `properties[shipping msg]`, exactly like production.
       Express variants (delivery_days 3|4) keep the server-rendered express line
       and skip the API, matching production's express-badge precedence. */
    var astraEddMessage='';
    function astraStashShipMsg(msg){
      astraEddMessage=msg||'';
      var si=document.getElementById('astraShippingMsg'); if(si)si.value=astraEddMessage;
    }
    function astraRevealDeliv(msg,data){
      var bar=document.getElementById('delivBar');
      var span=document.getElementById('astraEddMsg');
      var info=bar?bar.querySelector('.db-info'):null;
      if(!bar||!span)return;
      if(msg){ span.textContent=msg; bar.classList.remove('db-hidden'); if(info)info.classList.add('db-hidden'); }
      else{ span.textContent=''; bar.classList.add('db-hidden'); }
      astraStashShipMsg(msg);
      astraTogglePreorder(msg,data);
    }

    /* ===== Pre-order note (FR-4 item 3) =====================================
       The pre-order strip is derived from the very same EDD payload as the
       delivery bar above - the live per-SKU estimate - so the two lines can
       never disagree on the page. It shows only for a genuinely long lead
       time: 8 weeks and beyond (threshold from data-min-weeks), or an estimate
       quoted in months rather than weeks.

       The threshold reads the LOWER bound of a range, which is the earliest
       the item can arrive: "Delivered in 5-8 weeks" is a 5-week lead time and
       stays out of pre-order, while "Delivered in 8-10 weeks" crosses it.
       Ranges come back with an en dash from the API but hyphen / em dash /
       "to" are accepted too, since the copy is authored upstream.

       Messages that quote a calendar date instead of a duration ("Delivered
       by Late December") carry no weeks to parse, so the gap between today and
       the earliest promised date (min_edd) is measured instead - same lower-
       bound rule, same threshold.

       Anything else leaves the strip hidden: express variants, day-based
       estimates, an API error, a blank message, or copy we cannot parse. A
       pre-order claim we cannot substantiate is worse than no claim at all.

       The API also returns its own `is_preorder` flag, deliberately not used
       as the trigger: it is set by the fulfilment side on stock position, and
       the ticket defines the customer-facing tag purely by quoted lead time. */
    function astraPreorderIsLong(msg,data){
      var el=document.getElementById('astraPreorder'); if(!el)return false;
      var min=Number(el.getAttribute('data-min-weeks'))||8;
      var text=String(msg||'').toLowerCase();
      /* a lead time quoted in months is a pre-order whatever the number */
      if(/\bmonths?\b/.test(text))return true;
      /* "5-8 weeks" / "8 weeks" / "8 to 10 weeks" -> take the first number */
      var wk=text.match(/(\d+)\s*(?:[-–—]|to)?\s*\d*\s*weeks?\b/);
      if(wk)return Number(wk[1])>=min;
      /* an estimate in days is always inside the threshold */
      if(/\bdays?\b/.test(text))return false;
      /* no duration in the copy: fall back to the earliest promised date */
      var iso=data&&(data.min_edd||data.max_edd);
      if(iso){
        var t=Date.parse(String(iso)+'T00:00:00');
        if(!isNaN(t))return ((t-Date.now())/86400000)/7>=min;
      }
      return false;
    }
    function astraTogglePreorder(msg,data){
      var el=document.getElementById('astraPreorder'); if(!el)return;
      el.classList.toggle('db-hidden',!astraPreorderIsLong(msg,data));
    }
    function astraUpdateEDD(sku, deliveryDays){
      var bar=document.getElementById('delivBar'); if(!bar)return;
      var dd=Number(deliveryDays)||0;
      bar.setAttribute('data-days',dd);
      /* express: keep the server-rendered "Express Delivery in N working days".
         data-express drives the strip's colour scheme (maroon vs grey) in CSS. */
      if(dd===3||dd===4){
        bar.setAttribute('data-express','true');
        var span=document.getElementById('astraEddMsg');
        var info=bar.querySelector('.db-info');
        var tmpl=bar.getAttribute('data-express-tmpl')||'';
        /* rebuild the localized express line for this variant's day count
           (keeps it correct when switching into an express variant) */
        var exMsg=tmpl?tmpl.replace('__DAYS__',dd):(span?span.textContent.trim():'');
        if(span)span.textContent=exMsg;
        astraStashShipMsg(exMsg);
        bar.classList.remove('db-hidden'); if(info)info.classList.remove('db-hidden');
        astraTogglePreorder('');                /* express is never a pre-order */
        return;
      }
      bar.setAttribute('data-express','false');
      bar.classList.add('db-hidden');           /* hidden until the API answers */
      astraStashShipMsg('');
      astraTogglePreorder('');                  /* ditto - no claim until it does */
      if(!sku)return;
      fetch('https://api.trampolinestore.uk/fableroom/edd/?format=json&sku='+encodeURIComponent(sku))
        .then(function(r){return r.json();})
        .then(function(data){
          if(!data||data.error){astraRevealDeliv('');return;}
          var msg=(data.message||data.shipping_message||'').trim();
          astraRevealDeliv(msg,data);
        })
        .catch(function(err){ try{console.warn('[astra] EDD API error',err);}catch(e){} astraRevealDeliv(''); });
    }

    /* ===== Phase 4: real cart (theme AJAX) + FBT + price math ================
       Adds via POST /cart/add.js, then refreshes + opens the theme's cart
       drawer with its documented events (dispatch:cart-drawer:refresh / :open),
       mirroring the theme's own add pattern in assets/custom.js. Money is
       formatted with the theme's window.theme.settings.moneyFormat. */
    /* keepDecimals: keep a trailing ".00" instead of trimming it, for amounts that
       sit next to server-rendered `| money` output (BNPL instalments) rather than
       the trimmed `| money_without_trailing_zeros` style used for the FBT total. */
    function astraMoney(cents,keepDecimals){
      cents=Number(cents); if(isNaN(cents))return '';
      var fmt=(window.theme&&window.theme.settings&&window.theme.settings.moneyFormat)||'£{{amount}}';
      var amt=(cents/100).toFixed(2), noDec=keepDecimals?amt:amt.replace(/\.00$/,''),
          comma=amt.replace('.',','), commaNoDec=keepDecimals?comma:comma.replace(/,00$/,'');
      return fmt.replace('{{amount}}',noDec).replace('{{ amount }}',noDec)
                .replace('{{amount_with_comma_separator}}',commaNoDec).replace('{{ amount_with_comma_separator }}',commaNoDec)
                .replace('{{amount_no_decimals}}',Math.round(cents/100)).replace('{{ amount_no_decimals }}',Math.round(cents/100))
                .replace('{{amount_no_decimals_with_comma_separator}}',Math.round(cents/100));
    }
    function astraCartAdd(items, btn){
      if(!items||!items.length)return;
      var oldTxt=btn?btn.textContent:null;
      if(btn){btn.disabled=true; btn.textContent='Adding…';}
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:items})})
        .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
        .then(function(res){
          if(!res.ok)throw (res.d&&res.d.description)||'Could not add to cart';
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh',{bubbles:true}));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open',{bubbles:true}));
        })
        .catch(function(err){ try{console.warn('[astra] cart add failed',err);}catch(e){}
          window.alert(typeof err==='string'?err:'Sorry, this item could not be added to your basket.'); })
        .finally(function(){ if(btn){btn.disabled=false; if(oldTxt!=null)btn.textContent=oldTxt;} });
    }
    function astraCurrentAdd(btn){
      var idEl=document.getElementById('astraVariantId'), qEl=document.getElementById('qtyv');
      var id=idEl&&idEl.value; if(!id)return;
      var q=qEl?(parseInt(qEl.value,10)||1):1;
      var item={id:id,quantity:q};
      /* carry the live delivery message onto the order line, like production */
      if(astraEddMessage)item.properties={'shipping msg':astraEddMessage};
      astraCartAdd([item], btn);
    }
    /* main buy form (progressive enhancement: native submit -> /cart without JS) */
    var __bf=document.querySelector('.astra-pdp form.astra-buyform');
    if(__bf)__bf.addEventListener('submit',function(e){e.preventDefault();
      if(document.getElementById('mainAtc') && document.getElementById('mainAtc').disabled)return;
      astraCurrentAdd(document.getElementById('mainAtc'));});
    /* sticky-bar button */
    var __sb=document.querySelector('.astra-pdp .sb-btn');
    if(__sb)__sb.addEventListener('click',function(){ if(!__sb.disabled)astraCurrentAdd(__sb); });
    /* frequently-bought-together: add every checked item that has a real variant id */
    var __fbtCta=document.getElementById('fbtCta');
    if(__fbtCta)__fbtCta.addEventListener('click',function(){
      var items=[];
      document.querySelectorAll('.astra-pdp .fbt-item input:checked').forEach(function(c){
        var vid=c.getAttribute('data-variant-id'); if(vid)items.push({id:vid,quantity:1});
      });
      if(!items.length){window.alert('Please select at least one item to add.');return;}
      astraCartAdd(items, __fbtCta);
    });
    /* "Customers also loved" rail (sections/astra-also-loved.liquid): the bag
       button on a card carries the variant id when there is nothing to choose,
       so a click adds that one item and opens the cart drawer.
       v136: the rail's cards are now injected by Shopify's product
       recommendations fetch (the <product-recommendations> element in main.js),
       which lands long after astra() has run - so this is one delegated
       listener on document instead of a per-button bind. It catches cards that
       appear later, and the window guard keeps re-runs of astra()
       (shopify:section:load) from stacking a second listener.

       v135 per-button version, kept per never-delete convention:
       document.querySelectorAll('.astra-pdp .railcard button.ratc[data-variant-id]').forEach(function(btn){
         if(btn.getAttribute('data-astra-bound')==='1')return;
         btn.setAttribute('data-astra-bound','1');
         btn.addEventListener('click',function(e){
           e.preventDefault(); e.stopPropagation();
           if(btn.disabled)return;
           astraCartAdd([{id:btn.getAttribute('data-variant-id'),quantity:1}], btn);
         });
       });
    */
    if(!window.__astraRailAtcBound){
      window.__astraRailAtcBound=true;
      document.addEventListener('click',function(e){
        var t=e.target, btn=t&&t.closest?t.closest('.astra-pdp .railcard button.ratc[data-variant-id]'):null;
        if(!btn)return;
        e.preventDefault(); e.stopPropagation();
        if(btn.disabled)return;
        astraCartAdd([{id:btn.getAttribute('data-variant-id'),quantity:1}], btn);
      });
    }

    /* initial FBT totals from real prices (overrides server-rendered placeholder) */
    if(document.querySelector('.astra-pdp .fbt-items'))fbtCalc();

    /* initial delivery estimate for the first-rendered variant */
    (function(){
      var db=document.getElementById('delivBar'); if(!db)return;
      /* pass the variant's real delivery_days (data-days) so a 4-day express
         line isn't rewritten as 3 on first paint */
      astraUpdateEDD(db.getAttribute('data-sku'), db.getAttribute('data-days'));
    })();

/* preloader curtain (from Monit PDP) */
(function(){var loader=document.getElementById('loader');if(!loader)return;
  var reduceM=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var fin=function(){loader.classList.add('done')};
  if(reduceM){fin();}
  else{window.addEventListener('load',function(){setTimeout(fin,520)},{once:true});setTimeout(fin,1650);}
  /* _25 ADD: reveal the cookie consent bar exactly when the preloader
     is actually gone, not on a fixed delay guessed to outlast it. Was
     previously visible from page load with no gate at all - could
     appear on top of / underneath the preloader curtain depending on
     timing. Hooked into both real exits (transitionend) and the hard
     fallback (2800ms), same as the loader's own display:none logic,
     so consent reveal always tracks the loader's real fate.
     _27 FIX: this had a real bug - BOTH the transitionend listener and
     the 2800ms fallback called revealConsent(), with nothing to stop
     the second one firing after the first already had. If someone
     clicked Decline/Accept quickly (before 2800ms), the fallback timer
     was still pending and would fire later, un-hiding the bar again
     right after they'd dismissed it. Fixed two ways: (1) whichever
     path fires first now cancels the other, so revealConsent only
     ever actually runs once; (2) revealConsent also checks a
     window.consentDismissed flag (set by closeConsent()) and refuses
     to reveal at all once the person has made a choice, as a second,
     independent guard against this class of bug. */
  window.consentDismissed=false;
  var revealTimer=setTimeout(function(){loader.style.display='none';revealConsent();},2800);
  function revealConsent(){
    clearTimeout(revealTimer);
    if(window.consentDismissed)return;
    var consent=document.getElementById('consent'),backdrop=document.getElementById('consentBackdrop');
    if(consent)consent.classList.remove('hide');
    if(backdrop)backdrop.classList.add('show');
  }
  loader.addEventListener('transitionend',function(){loader.style.display='none';revealConsent();},{once:true});
})();

var _AD=(function(){var n=document.getElementById("astra-pdp-data");try{return n?JSON.parse(n.textContent):{};}catch(e){return {};}})();
var IMGDIR="";
var imgs=(_AD.images&&_AD.images.length)?_AD.images:[];

/* Rotating slide-badge tags, built from THIS product's real badge data.
   The wording is never invented here: _AD.badges is the product's own
   custom.product_badge list plus the selected variant's
   badge.variant_badge list (snippets/astra-gallery-badges.liquid), i.e.
   exactly the badges the product cards rotate through - so a card and
   this gallery can't disagree. A product with no badge metafields gets
   no authored badge at all (the mockup's hard-coded "Pre-Order" +
   "Bestseller" pair used to show on every product regardless).

   The one computed badge is "X% Off": included only when the SELECTED
   variant is actually on sale (compare_at_price > price), with the
   percentage from that variant, and suppressed in Germany where the
   theme hides discount badges everywhere else too (_AD.saleBadge). It
   goes FIRST so the solid-red badge is what renders on load (matches
   the design); a white/pale badge would disappear against light shots.

   Sold-out variants get no badges, matching the cards, which drop the
   whole strip rather than promote something you can't buy. */
var badgeTags=[];
function astraBadgeCls(text){
  var t=String(text).toLowerCase();
  if(t.indexOf('pre order')>-1||t.indexOf('pre-order')>-1||t.indexOf('preorder')>-1)return 'b-pre';
  return 'b-best';
}
function astraBuildBadgeTags(onSale,pct,list,available){
  var out=[];
  if(available===false)return out;
  if(_AD.saleBadge!==false&&onSale&&pct>0)out.push({text:pct+'% Off',cls:'b-sale'});
  (list||[]).forEach(function(text){
    var t=(text==null?'':String(text)).trim();
    if(t)out.push({text:t,cls:astraBadgeCls(t)});
  });
  return out;
}
badgeTags=astraBuildBadgeTags(_AD.onSale,_AD.savePct,_AD.badges,_AD.available);

/* Campaign / "sale" badge - the one the LIVE PDP already shows in the
   gallery's top-left corner ("Summer Sale"), read from the product's
   pb1_..pb4_ tags by snippets/astra-sale-badge.liquid. It is painted into
   the SAME .slide-badges column as the badges above but always as the first
   child, so it keeps the live top-left slot and the metafield badges stack
   below it; a product with no campaign tag has no first child at all and
   those badges sit back at the top on their own.
   Suppressed on a sold-out variant, exactly as live does and exactly as the
   metafield badges above do. */
var saleTags=[];
function astraBuildSaleTags(available){
  if(available===false)return [];
  return (_AD.saleTags||[]).filter(function(t){return t&&t.text;});
}
saleTags=astraBuildSaleTags(_AD.available);

var gi=0,gtrack=document.getElementById('gTrack'),gthumbs=document.getElementById('gthumbs');
if(!__hasServerGallery){
  imgs.forEach(function(o,i){
    /* build slide - full-size image, part of the native scroll-snap track */
    var slide=document.createElement('div');
    slide.className='g-slide';
    var slideImg=document.createElement('img');
    slideImg.alt=o.a; slideImg.loading=i===0?'eager':'lazy';
    slideImg.src=IMGDIR+o.f;
    slide.appendChild(slideImg);
    /* per-slide overlays - loved-strip AND badge are both per-slide,
       matching mainline v125's original pattern. Badge uses a shared
       CLASS "dyn-badge" (not a unique id) so the rotating-badge JS below
       can update all 8 instances together each cycle, keeping every
       slide's badge dynamic and in sync while each stays physically
       attached to its own image.
       The box is always built, even for a product with no badges: it is
       an empty absolutely-positioned div (nothing renders) and it means a
       variant switch that DOES have badges has somewhere to paint them. */
    var slideBadges=document.createElement('div');
    slideBadges.className='slide-badges';
    slide.appendChild(slideBadges);
    var slideLoved=document.createElement('div');
    /* loved copy is per-product merchant data (custom.pdp_trust_badge, serialised
       into _AD.loved) - no literal fallback. With none set the strip keeps only the
       expand control, so --bare drops its dark bar. Text goes in via textContent,
       never innerHTML: it is merchant-authored. */
    var lovedTxt=(_AD&&_AD.loved)||'';
    slideLoved.className='slide-loved-strip'+(lovedTxt?'':' slide-loved-strip--bare');
    slideLoved.innerHTML=(lovedTxt?'<span class="slide-loved-main"><svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 1 0-7.8 7.8L12 21.2l8.8-8.8a5.5 5.5 0 0 0 0-7.8z"/></svg> <span class="slide-loved-txt"></span></span>':'')+'<span class="slide-expand" aria-label="View full gallery"><svg width="12.35" height="12.35" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M8 21H5a2 2 0 0 1-2-2v-3"/></svg></span>';
    if(lovedTxt)slideLoved.querySelector('.slide-loved-txt').textContent=lovedTxt;
    slide.appendChild(slideLoved);
    gtrack.appendChild(slide);

    var t=document.createElement('button');
    t.className='thumb'+(i===0?' active':'');
    t.setAttribute('role','tab');
    t.setAttribute('aria-label',o.a);
    t.setAttribute('aria-selected',i===0?'true':'false');
    /* build thumb  -  apply bg swap to product shots */
    var thumbImgEl=document.createElement('img');
    thumbImgEl.alt=''; thumbImgEl.loading='lazy';
    thumbImgEl.src=IMGDIR+o.f;
    var thDiv=document.createElement('div'); thDiv.className='th-img';
    thDiv.appendChild(thumbImgEl);
    t.appendChild(thDiv);
    /* only render the tag label when a tag exists — no default/alt-derived fallback text */
    if(o.label){ var lbl=document.createElement('span'); lbl.className='th-lbl'; lbl.textContent=o.label; t.appendChild(lbl); }
    t.onclick=function(){
      var gEl=document.querySelector('.g-main');
      var r=gEl?gEl.getBoundingClientRect():null;
      /* scroll to gallery if it's scrolled off above (mobile)  -  on desktop gallery is sticky so always visible */
      var needsScroll=r?(r.bottom<60):false;
      show(i,needsScroll);
    };
    gthumbs.appendChild(t);
  });
}else{
  /* slides/thumbs are already in the DOM (server-rendered by Liquid) -
     just wire up the one bit of behaviour markup can't express: jumping
     the gallery to a slide when its thumb is clicked. */
  Array.prototype.forEach.call(gthumbs.querySelectorAll('.thumb'),function(t,i){
    t.onclick=function(){
      var gEl=document.querySelector('.g-main');
      var r=gEl?gEl.getBoundingClientRect():null;
      var needsScroll=r?(r.bottom<60):false;
      show(i,needsScroll);
    };
  });
}

/* ── state sync (thumbs, badges, Ken Burns, lightbox) - does NOT move the track ── */
function setActiveState(i){
  gi=i;
  var slides=gtrack.querySelectorAll('.g-slide');
  var slideImgs=gtrack.querySelectorAll('.g-slide img');
  var subtleSlides=[2,4];
  slides.forEach(function(s,k){ s.classList.toggle('active-slide',k===i); });
  slideImgs.forEach(function(im,k){
    im.style.animation='none';
    if(k===i){
      im.getBoundingClientRect();
      im.style.animation='';
      im.style.animationName=subtleSlides.indexOf(i)>-1?'kb-subtle':'kb';
    }
  });
  document.querySelectorAll('.thumb').forEach(function(d,k){
    var on=k===i;
    d.classList.toggle('active',on);
    d.setAttribute('aria-selected',on?'true':'false');
  });
  /* old .g-badges dim-toggle removed - badges are now per-slide, each
     slide's own badge is only ever visible when that slide is (no
     separate dim/undim needed) */
  /* desktop prev/next arrows - disable at the ends (no wraparound) */
  var prevBtn=document.getElementById('gArrowPrev'),nextBtn=document.getElementById('gArrowNext');
  if(prevBtn)prevBtn.disabled=(i===0);
  if(nextBtn)nextBtn.disabled=(i===imgs.length-1);
  /* scroll active thumb into view - works for both left and right directions */
  var atv=gthumbs.querySelectorAll('.thumb')[i];
  if(atv){atv.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'})}
  /* keep lightbox in sync if it happens to be open */
  if(typeof lbSyncIfOpen==='function')lbSyncIfOpen();
  /* desktop: scroll the vertical thumbstrip so active thumb is visible */
  if(window.innerWidth>=820){
    var tc=document.getElementById('gthumbs');
    var atd=tc?tc.querySelectorAll('.thumb')[i]:null;
    if(tc&&atd){
      var thumbH=84+7;
      var targetScroll=i*thumbH;
      tc.scrollTo({top:targetScroll,behavior:'smooth'});
    }
  }
}
/* ── moves the actual carousel to slide i - only meaningful on mobile
   (native scroll-snap does the swipe motion itself). v-branch note:
   this comment used to say desktop was a harmless no-op here because
   .g-track had overflow:hidden - that's no longer true post-gallery-
   rebuild (desktop is now a flowing wrapped grid with overflow:visible),
   so scrollIntoView here could now actually trigger an unwanted page
   jump on desktop (same root issue just fixed in centerNav). Guarded
   with an explicit desktop check so it's a REAL no-op there again. ── */
function scrollTrackTo(i){
  if(window.matchMedia('(min-width:820px)').matches)return;
  var slides=gtrack.querySelectorAll('.g-slide');
  if(slides[i]){slides[i].scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'})}
}
function show(i, scrollToGallery){
  scrollTrackTo(i);
  setActiveState(i);
  if(scrollToGallery){
    var gallery=document.querySelector('.gallery');
    if(gallery){
      var top=gallery.getBoundingClientRect().top+window.scrollY-90;
      window.scrollTo({top:top,behavior:'smooth'});
    }
  }
}
setActiveState(0);

/* desktop prev/next arrow navigation - mobile hides these via CSS, but
   guard the click logic too so nothing fires from an invisible button */
(function(){
  var prevBtn=document.getElementById('gArrowPrev'),nextBtn=document.getElementById('gArrowNext');
  if(prevBtn)prevBtn.addEventListener('click',function(){ if(gi>0)show(gi-1); });
  if(nextBtn)nextBtn.addEventListener('click',function(){ if(gi<imgs.length-1)show(gi+1); });
})();

/* ── Gallery track: real swipe/scroll is native (scroll-snap); this just (1) detects which
   slide is centered after a swipe settles, to keep thumbs/badges/lightbox in sync, and
   (2) distinguishes a tap (opens lightbox) from a drag (just scrolling) ── */
(function(){
  if(!gtrack)return;
  var sx=0,sy=0,dragged=false;
  gtrack.addEventListener('touchstart',function(e){
    sx=e.touches[0].clientX;sy=e.touches[0].clientY;dragged=false;
  },{passive:true});
  gtrack.addEventListener('touchmove',function(e){
    if(Math.abs(e.touches[0].clientX-sx)>6||Math.abs(e.touches[0].clientY-sy)>6)dragged=true;
  },{passive:true});
  var scrollTimer=null;
  gtrack.addEventListener('scroll',function(){
    clearTimeout(scrollTimer);
    scrollTimer=setTimeout(function(){
      var slides=gtrack.querySelectorAll('.g-slide');
      var trackRect=gtrack.getBoundingClientRect();
      var centerX=trackRect.left+trackRect.width/2;
      var closest=0,closestDist=Infinity;
      slides.forEach(function(s,idx){
        var r=s.getBoundingClientRect();
        var d=Math.abs((r.left+r.width/2)-centerX);
        if(d<closestDist){closestDist=d;closest=idx;}
      });
      if(closest!==gi)setActiveState(closest);
    },110);
  },{passive:true});
  /* v-branch: DESKTOP GALLERY REBUILD note - on desktop, images are no
     longer a single-active-slide carousel (they all sit in a flowing
     wrapped grid, see CSS), so the old "current slide" (gi) tracked by
     the scroll listener above isn't meaningful there anymore - it would
     always open the lightbox on whichever slide gi happened to last be
     set to, regardless of which image was actually clicked. Fixed by
     resolving the clicked slide's own index directly from the event
     target, which works correctly on both mobile (still gi-driven,
     since there's only ever one slide really "clicked") and desktop
     (each grid image resolves to its own index). */
  gtrack.addEventListener('click',function(e){
    if(dragged)return;
    var clickedSlide=e.target.closest('.g-slide');
    if(clickedSlide){
      var allSlides=Array.prototype.slice.call(gtrack.querySelectorAll('.g-slide'));
      var idx=allSlides.indexOf(clickedSlide);
      openLightbox(idx>=0?idx:gi);
    }else{
      openLightbox(gi);
    }
  });
})();

/* ── Fullscreen gallery lightbox ── */
/* Zoom model: #lbImg is transformed as `translate(panX,panY) scale(zoom)`.
   Because scale() runs before translate() in that composed transform, panX/
   panY are plain screen pixels regardless of zoom level, which keeps the
   pan math in lbZoomAt/lbClampPan simple (no /zoom correction needed). Reset
   on every slide change (lbShow) so zoom never carries over to the next
   image. Desktop gets scroll-wheel zoom (anchored under the cursor) plus the
   visible −/%/+/reset bar (#lbZoom, shown only at the desktop breakpoint);
   touch gets pinch-zoom, single-finger pan while zoomed, and double-tap to
   reset - see the touchstart/move/end block below. */
var lb={el:null,img:null,counter:null,thumbsWrap:null,stage:null,pctEl:null,index:0,open:false,zoom:1,panX:0,panY:0,minZoom:1,maxZoom:4};
function lbApplyTransform(){
  lb.img.style.transform='translate('+lb.panX+'px,'+lb.panY+'px) scale('+lb.zoom+')';
  if(lb.pctEl)lb.pctEl.textContent=Math.round(lb.zoom*100)+'%';
  if(lb.stage)lb.stage.classList.toggle('zoomed',lb.zoom>1.001);
}
function lbClampPan(){
  if(!lb.stage)return;
  var r=lb.stage.getBoundingClientRect();
  var maxX=Math.max(0,(lb.zoom-1)*r.width/2);
  var maxY=Math.max(0,(lb.zoom-1)*r.height/2);
  lb.panX=Math.max(-maxX,Math.min(maxX,lb.panX));
  lb.panY=Math.max(-maxY,Math.min(maxY,lb.panY));
}
/* Zooms to newZoom while keeping the point at (clientX,clientY) stationary
   on screen - the standard cursor/pinch-midpoint-anchored zoom formula. */
function lbZoomAt(newZoom,clientX,clientY){
  if(!lb.stage)return;
  newZoom=Math.max(lb.minZoom,Math.min(lb.maxZoom,newZoom));
  var r=lb.stage.getBoundingClientRect();
  var ox=clientX-r.left-r.width/2,oy=clientY-r.top-r.height/2;
  var ratio=newZoom/lb.zoom;
  lb.panX=ox-(ox-lb.panX)*ratio;
  lb.panY=oy-(oy-lb.panY)*ratio;
  lb.zoom=newZoom;
  lbClampPan();
  lbApplyTransform();
}
function lbZoomStep(dir){
  if(!lb.stage)return;
  var r=lb.stage.getBoundingClientRect();
  lbZoomAt(lb.zoom+dir*0.5,r.left+r.width/2,r.top+r.height/2);
}
function lbZoomReset(){
  lb.zoom=1;lb.panX=0;lb.panY=0;
  lbApplyTransform();
}
function initLightbox(){
  lb.el=document.getElementById('lightbox');
  lb.img=document.getElementById('lbImg');
  lb.counter=document.getElementById('lbCounter');
  lb.thumbsWrap=document.getElementById('lbThumbs');
  lb.pctEl=document.getElementById('lbZoomPct');
  if(!lb.el||!lb.thumbsWrap)return;
  imgs.forEach(function(o,i){
    var t=document.createElement('img');
    t.src=IMGDIR+o.f;
    t.alt=o.a;
    t.loading='lazy';
    t.onclick=function(){lbShow(i)};
    lb.thumbsWrap.appendChild(t);
  });
  var stage=document.getElementById('lbStage');
  lb.stage=stage;

  /* desktop: scroll-wheel zoom, anchored under the cursor */
  stage.addEventListener('wheel',function(e){
    e.preventDefault();
    lbZoomAt(lb.zoom-e.deltaY*0.0015*lb.zoom,e.clientX,e.clientY);
  },{passive:false});

  /* touch: pinch-zoom (2 fingers), pan while zoomed (1 finger), swipe to
     change slides (1 finger, only while not zoomed), double-tap to reset */
  var sx=0,sy=0,pinching=false,pinchStartDist=0,pinchStartZoom=1,panning=false,lastX=0,lastY=0,moved=false,lastTapT=0,lastTapX=0,lastTapY=0;
  function tDist(t0,t1){var dx=t0.clientX-t1.clientX,dy=t0.clientY-t1.clientY;return Math.sqrt(dx*dx+dy*dy)}
  function tMid(t0,t1){return{x:(t0.clientX+t1.clientX)/2,y:(t0.clientY+t1.clientY)/2}}
  stage.addEventListener('touchstart',function(e){
    moved=false;
    if(e.touches.length===2){
      pinching=true;panning=false;
      pinchStartDist=tDist(e.touches[0],e.touches[1])||1;
      pinchStartZoom=lb.zoom;
      stage.classList.add('lb-no-anim');
    }else if(e.touches.length===1){
      sx=e.touches[0].clientX;sy=e.touches[0].clientY;
      if(lb.zoom>1.001){
        panning=true;
        lastX=sx;lastY=sy;
        stage.classList.add('lb-no-anim');
      }
    }
  },{passive:true});
  stage.addEventListener('touchmove',function(e){
    if(pinching&&e.touches.length===2){
      e.preventDefault();
      var d=tDist(e.touches[0],e.touches[1]),m=tMid(e.touches[0],e.touches[1]);
      lbZoomAt(pinchStartZoom*(d/pinchStartDist),m.x,m.y);
      moved=true;
    }else if(panning&&e.touches.length===1){
      e.preventDefault();
      var t=e.touches[0];
      lb.panX+=t.clientX-lastX;
      lb.panY+=t.clientY-lastY;
      lastX=t.clientX;lastY=t.clientY;
      lbClampPan();
      lbApplyTransform();
      moved=true;
    }else if(e.touches.length===1&&(Math.abs(e.touches[0].clientX-sx)>6||Math.abs(e.touches[0].clientY-sy)>6)){
      moved=true;
    }
  },{passive:false});
  stage.addEventListener('touchend',function(e){
    stage.classList.remove('lb-no-anim');
    if(pinching){pinching=false;return}
    /* NOT an early return on `panning` - a tap while zoomed also starts as a
       pan candidate (touchstart sets panning=true whenever zoom>1), so
       bailing out here would make double-tap-to-reset unreachable exactly
       when it's needed. `moved` (set in touchmove once a real drag happens)
       is what actually distinguishes a stationary tap from a pan/swipe. */
    panning=false;
    var now=Date.now(),ct=e.changedTouches[0];
    if(!moved&&now-lastTapT<320&&Math.abs(ct.clientX-lastTapX)<30&&Math.abs(ct.clientY-lastTapY)<30){
      lbZoomReset();
      lastTapT=0;
      return;
    }
    lastTapT=now;lastTapX=ct.clientX;lastTapY=ct.clientY;
    if(lb.zoom<=1.001){
      var dx=ct.clientX-sx;
      if(Math.abs(dx)>40){lbNav(dx<0?1:-1)}
    }
  },{passive:true});

  document.addEventListener('keydown',function(e){
    if(!lb.open)return;
    if(e.key==='Escape')closeLightbox();
    if(e.key==='ArrowRight')lbNav(1);
    if(e.key==='ArrowLeft')lbNav(-1);
    if(e.key==='+'||e.key==='=')lbZoomStep(1);
    if(e.key==='-')lbZoomStep(-1);
    if(e.key==='0')lbZoomReset();
  });
}
function lbShow(i){
  lb.index=(i+imgs.length)%imgs.length;
  lb.img.src=IMGDIR+imgs[lb.index].f;
  lb.img.alt=imgs[lb.index].a;
  lb.counter.textContent=(lb.index+1)+' / '+imgs.length;
  lbZoomReset();
  lb.thumbsWrap.querySelectorAll('img').forEach(function(t,k){
    t.classList.toggle('active',k===lb.index);
    if(k===lb.index)t.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  });
}
function openLightbox(i){
  if(!lb.el)initLightbox();
  lbShow(i);
  lb.el.classList.add('show');
  lb.open=true;
  document.body.style.overflow='hidden';
}
function closeLightbox(){
  if(!lb.el)return;
  lb.el.classList.remove('show');
  lb.open=false;
  document.body.style.overflow='';
  lbZoomReset();
  /* keep the main gallery in sync with whatever was last viewed in the lightbox */
  show(lb.index);
}
function lbNav(dir){
  lbShow(lb.index+dir);
}
function lbSyncIfOpen(){
  if(typeof lb==='undefined'||!lb.open)return;
  lbShow(gi);
}

/* _59 ADD: CARD LIGHTBOX engine for the Pillars + Craft carousels.
   Reads each carousel's cards straight from the DOM (image src/alt,
   optional step tag, heading, paragraph) so the lightbox content always
   matches whatever's in the markup - no separate hardcoded data array to
   keep in sync. Clicking any card opens the overlay at that card; arrows/
   swipe/keyboard cycle within that same carousel's set only. */
var clb={el:null,img:null,tag:null,heading:null,text:null,counter:null,thumbsWrap:null,set:[],index:0,open:false};
function clbCollect(){
  var sets={};
  /* Pillars: .fb-slide > .bento-lifestyle (img + .bl-cap h3/p), no step tag */
  sets.pillars=[].slice.call(document.querySelectorAll('#pillarsCarouselCol .fb-slide')).map(function(s){
    var img=s.querySelector('img'), h=s.querySelector('.bl-cap h3'), p=s.querySelector('.bl-cap p');
    return {src:img?img.getAttribute('src'):'', alt:img?img.getAttribute('alt'):'', tag:'', heading:h?h.textContent:'', text:p?p.textContent:''};
  });
  /* Craft: .craft-slide (img + .craft-slide-copy .craft-step-tag/h4/p), has step tag */
  sets.craft=[].slice.call(document.querySelectorAll('#craftTrack .craft-slide')).map(function(s){
    var img=s.querySelector('img'), tag=s.querySelector('.craft-step-tag'), h=s.querySelector('.craft-slide-copy h4'), p=s.querySelector('.craft-slide-copy p');
    return {src:img?img.getAttribute('src'):'', alt:img?img.getAttribute('alt'):'', tag:tag?tag.textContent:'', heading:h?h.textContent:'', text:p?p.textContent:''};
  });
  return sets;
}
function clbInit(){
  clb.el=document.getElementById('cardLightbox');
  clb.img=document.getElementById('clbImg');
  clb.tag=document.getElementById('clbTag');
  clb.heading=document.getElementById('clbHeading');
  clb.text=document.getElementById('clbText');
  clb.counter=document.getElementById('clbCounter');
  clb.thumbsWrap=document.getElementById('clbThumbs');
  if(!clb.el)return;
  var sets=clbCollect();
  /* wire each Pillars card */
  [].slice.call(document.querySelectorAll('#pillarsCarouselCol .fb-slide')).forEach(function(s,i){
    var target=s.querySelector('.bento-lifestyle')||s;
    target.addEventListener('click',function(){
      /* ignore the click that fires at the tail of a carousel drag */
      var track=s.closest('.fb-carousel')&&s.closest('.fb-carousel').querySelector('.fb-track');
      if(track&&track._fbDragged)return;
      openCardLightbox('pillars',i);
    });
  });
  /* wire each Craft card */
  [].slice.call(document.querySelectorAll('#craftTrack .craft-slide')).forEach(function(s,i){
    s.addEventListener('click',function(){openCardLightbox('craft',i)});
  });
  /* _62: swipe now bound to the whole overlay (#cardLightbox), not just
     #clbStage - per direction to make sure it's reliably swipeable, a
     swipe anywhere on the screen (including over the caption or the
     empty area) now navigates, not only directly on the image. */
  var swipeZone=clb.el||document.getElementById('cardLightbox'), sx=0, sy=0;
  swipeZone.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY},{passive:true});
  swipeZone.addEventListener('touchend',function(e){
    var dx=e.changedTouches[0].clientX-sx, dy=e.changedTouches[0].clientY-sy;
    /* horizontal swipe only - ignore mostly-vertical gestures so a
       vertical scroll/flick doesn't accidentally change cards */
    if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){clbNav(dx<0?1:-1)}
  },{passive:true});
  document.addEventListener('keydown',function(e){
    if(!clb.open)return;
    if(e.key==='Escape')closeCardLightbox();
    if(e.key==='ArrowRight')clbNav(1);
    if(e.key==='ArrowLeft')clbNav(-1);
  });
}
function clbShow(i){
  if(!clb.set.length)return;
  clb.index=(i+clb.set.length)%clb.set.length;
  var c=clb.set[clb.index];
  clb.img.src=c.src; clb.img.alt=c.alt;
  if(c.tag){clb.tag.textContent=c.tag;clb.tag.style.display='';}else{clb.tag.style.display='none';}
  clb.heading.textContent=c.heading;
  clb.text.textContent=c.text;
  clb.counter.textContent=(clb.index+1)+' / '+clb.set.length;
  if(clb.thumbsWrap){
    clb.thumbsWrap.querySelectorAll('img').forEach(function(t,k){
      t.classList.toggle('active',k===clb.index);
      if(k===clb.index)t.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    });
  }
}
function clbBuildThumbs(){
  if(!clb.thumbsWrap)return;
  clb.thumbsWrap.innerHTML='';
  clb.set.forEach(function(c,i){
    var t=document.createElement('img');
    t.src=c.src; t.alt=c.alt; t.loading='lazy';
    t.onclick=function(){clbShow(i)};
    clb.thumbsWrap.appendChild(t);
  });
}
function openCardLightbox(which,i){
  if(!clb.el)clbInit();
  var sets=clbCollect();
  clb.set=sets[which]||[];
  clbBuildThumbs();
  clbShow(i);
  clb.el.classList.add('show');
  clb.open=true;
  document.body.style.overflow='hidden';
}
function closeCardLightbox(){
  if(!clb.el)return;
  clb.el.classList.remove('show');
  clb.open=false;
  document.body.style.overflow='';
}
function clbNav(dir){ clbShow(clb.index+dir); }
clbInit();

/* dynamic rotating badge - cycles through badgeTags (built above from
   this product's own badge metafields, plus the live sale percentage).
   v125-branch UPDATE: badges are per-slide (class="dyn-badge", 8
   instances) instead of a single #dynbadge overlay - paints ALL
   .slide-badges boxes in the same cycle, so they stay in sync while
   each remains attached to its own slide.
   The badge list is no longer fixed for the life of the page: a variant
   switch rebuilds it (different sale %, different variant_badge, sold
   out), so painting reads badgeTags fresh every tick and the interval
   runs even when there is currently nothing to rotate. */
var badgeIndex=0,saleIndex=0,badgeSwapTimer=null;
function astraPaintBadges(){
  var sale=saleTags.length?saleTags[saleIndex%saleTags.length]:null;
  var tag=badgeTags.length?badgeTags[badgeIndex%badgeTags.length]:null;
  document.querySelectorAll('.astra-pdp .slide-badges').forEach(function(box){
    /* campaign badge takes the top of the column - insertBefore(firstChild)
       keeps it above the metafield badge whichever of the two was built
       first. No campaign badge means no first child, so the metafield badge
       is back at the top of the image on its own. */
    var sb=box.querySelector('.sale-badge');
    if(!sale){
      if(sb)box.removeChild(sb);
    }else{
      if(!sb){ sb=document.createElement('span'); sb.className='sale-badge'; box.insertBefore(sb,box.firstChild); }
      sb.textContent=sale.text;
      /* both are cleared when the next tag in the rotation carries neither, or
         a tag with its own registered colour would leave its inline pair on the
         badge and the CSS defaults (--sale-badge-bg/-fg, the merchant's own
         settings) would never show through again. */
      sb.style.background=sale.bg||'';
      sb.style.color=sale.fg||'';
    }
    var badge=box.querySelector('.dyn-badge');
    if(!tag){ if(badge)box.removeChild(badge); return; }
    if(!badge){ badge=document.createElement('span'); box.appendChild(badge); }
    badge.className='badge b-dyn dyn-badge '+tag.cls;
    badge.textContent=tag.text;
  });
}
/* called on variant change - back to the first tag so the new variant's
   badge is on screen immediately rather than after the next tick. Drops a
   half-finished fade too, or a switch landing inside one of those 280ms
   windows would flip straight past the tag it just painted. */
function astraResetBadges(){
  if(badgeSwapTimer){clearTimeout(badgeSwapTimer);badgeSwapTimer=null;}
  badgeIndex=0;
  saleIndex=0;
  astraPaintBadges();
  document.querySelectorAll('.astra-pdp .dyn-badge,.astra-pdp .sale-badge').forEach(function(badge){badge.classList.remove('fade')});
}
astraPaintBadges();
/* astra() re-runs on shopify:section:load, so drop the previous timer or the
   theme editor ends up with several of them advancing the same badge.
   The two slots advance independently: the usual product has ONE campaign tag,
   which must stay pinned and unblinking while the metafield badges rotate
   underneath it, so only a slot with something to rotate is faded. */
if(window.__astraBadgeTimer)clearInterval(window.__astraBadgeTimer);
window.__astraBadgeTimer=setInterval(function(){
  var rotTags=badgeTags.length>1,rotSale=saleTags.length>1;
  if(!rotTags&&!rotSale)return; /* nothing to rotate with 0-1 tags in either slot */
  var sel=[];
  if(rotTags)sel.push('.astra-pdp .dyn-badge');
  if(rotSale)sel.push('.astra-pdp .sale-badge');
  sel=sel.join(',');
  document.querySelectorAll(sel).forEach(function(badge){badge.classList.add('fade')});
  badgeSwapTimer=setTimeout(function(){
    badgeSwapTimer=null;
    if(rotTags)badgeIndex=(badgeIndex+1)%badgeTags.length;
    if(rotSale)saleIndex=(saleIndex+1)%saleTags.length;
    astraPaintBadges();
    document.querySelectorAll(sel).forEach(function(badge){badge.classList.remove('fade')});
  },280);
},2500);

/* ---- BNPL vendor widgets (snippets/astra-bnpl-widgets.liquid) --------------
   Shop Pay, Klarna and PayPal each render their own message client-side, which
   needs a nudge in two cases the server render can't cover:

   1. Amounts are baked in at render time, so a variant switch would leave the
      previous price quoted.
   2. Klarna's placement and PayPal's iframe size themselves from the container,
      which is 0px wide while the collapsible panel / trust modal is
      display:none - so they must (re-)render after the container is visible.

   Every branch is guarded: the SDKs arrive async (Klarna as a store script_tag,
   PayPal from theme.liquid) and either can be blocked by cookie consent, in
   which case the row stays empty and CSS collapses it. */
window.astraRefreshBnpl=function astraRefreshBnpl(variantId,priceCents,root){
  var scope=root||document;
  var rows=scope.querySelectorAll('[data-astra-bnpl]');
  if(!rows.length)return;
  /* The Klarna OSM app polls the placements and forces data-purchase-amount
     back to the price it detects for itself, so writing the new amount alone
     gets reverted ("amount changed from 39600 to 18500" in its console log).
     It derives that price from ?variant=, which this PDP switches variants
     without touching - so sync the URL first and the app agrees with us.
     replaceState (not pushState) keeps the back button on page history. */
  if(variantId!=null&&window.history&&history.replaceState){
    try{
      var u=new URL(location.href);
      u.searchParams.set('variant',variantId);
      history.replaceState(history.state,'',u);
    }catch(e){}
  }
  if(priceCents!=null){
    /* Klarna wants minor units; PayPal a plain decimal (never `| money` - it
       can't parse "£503.00" and silently falls back to generic copy). */
    scope.querySelectorAll('klarna-placement').forEach(function(el){
      el.setAttribute('data-purchase-amount',String(priceCents));
    });
    var pp=(priceCents/100).toFixed(2);
    scope.querySelectorAll('[data-pp-message]').forEach(function(el){
      el.setAttribute('data-pp-amount',pp);
    });
  }
  if(variantId!=null){
    scope.querySelectorAll('.astra-bnpl-form input[name="id"]').forEach(function(el){el.value=variantId;});
    /* <shopify-payment-terms> carries a shopify-meta blob covering only the
       variant it was rendered for, so it can't be re-pointed client-side -
       hide the row instead of quoting the wrong variant, and let the section
       re-render (astraReloadBnpl) bring it back with the right figures. */
    var stale=false;
    scope.querySelectorAll('shopify-payment-terms').forEach(function(el){
      var meta={},ok=false;
      try{meta=JSON.parse(el.getAttribute('shopify-meta')||'{}');}catch(e){}
      (meta.variants||[]).forEach(function(v){if(String(v.id)===String(variantId))ok=true;});
      var row=el.closest('.astra-bnpl-row');
      if(row)row.toggleAttribute('data-astra-bnpl-empty',!ok);
      if(ok)el.setAttribute('variant-id',String(variantId));else stale=true;
    });
    if(stale)window.astraReloadBnpl(variantId);
  }
  try{if(window.Klarna&&window.Klarna.OnsiteMessaging)window.Klarna.OnsiteMessaging.refresh();}catch(e){}
  try{
    var sdk=window.PayPalSDK||window.paypal;
    if(sdk&&sdk.Messages){
      scope.querySelectorAll('[data-pp-message]').forEach(function(el){
        /* PayPal sizes its iframe from the container, so only touch containers
           that are actually laid out - clearing a collapsed one would blank the
           widget with nothing able to bring it back until the panel's own open
           handler fires (which is what re-renders it there). */
        if(!el.offsetParent||!el.getBoundingClientRect().width)return;
        var amt=parseFloat(el.getAttribute('data-pp-amount'));
        if(el.getAttribute('data-astra-pp-rendered')===String(amt))return;
        el.setAttribute('data-astra-pp-rendered',String(amt));
        el.innerHTML='';  /* render() appends, so clear or re-opening stacks iframes */
        sdk.Messages({
          amount:amt||undefined,
          style:{layout:'text',logo:{type:'inline'},text:{color:'black'}}
        }).render(el);
      });
    }
  }catch(e){}
};
/* The Klarna OSM app injects its SDK from a store script_tag that can land ~30s
   after load (its own log: "Klarna OSM Script Tag has been added successfully").
   A shopper who opens the BNPL panel before then gets nothing, because the only
   other render trigger is that open handler. So watch for the placements filling
   in and refresh whatever is on screen once they do - bounded, and it stops as
   soon as every placement has rendered (or we give up), so there's no permanent
   timer. */
function astraWatchBnpl(){
  var placements=document.querySelectorAll('.astra-pdp klarna-placement');
  if(!placements.length)return;
  var tries=0;
  (function poll(){
    var pending=false;
    placements.forEach(function(k){
      /* an unrendered placement has no shadow root and no height; one whose
         container was hidden at render time has a shadow root but no height */
      if(!k.shadowRoot||!k.getBoundingClientRect().height)pending=true;
    });
    if(!pending)return;
    if(window.Klarna&&window.Klarna.OnsiteMessaging){
      document.querySelectorAll('.astra-pdp [data-astra-bnpl]').forEach(function(g){
        if(g.offsetParent)window.astraRefreshBnpl(null,null,g);
      });
    }
    if(++tries<20)setTimeout(poll,3000);   /* ~60s, then give up */
  })();
}
/* Re-render the Shop Pay terms for a variant the live markup can't cover, via
   the Section Rendering API (`?variant=` drives
   product.selected_or_first_available_variant). Only the payment-terms row is
   swapped - Klarna/PayPal are handled by the attribute updates above.

   The widgets live in more than one section (buy box + trust modal in astra-pdp,
   Finance accordion in astra-delivery), so fetch each section that actually has
   a stale row and match rows back by their own instance id - pairing them off by
   document order would skew as soon as one section's rows are missing. */
window.astraReloadBnpl=function astraReloadBnpl(variantId){
  var cfg={},data=document.getElementById('astra-variants-data');
  try{cfg=JSON.parse(data.textContent);}catch(e){}
  if(!cfg.url)return;
  var stale={};
  document.querySelectorAll('.astra-pdp [data-astra-bnpl]').forEach(function(g){
    var row=g.querySelector('.astra-bnpl-row--shoppay');
    if(row&&row.hasAttribute('data-astra-bnpl-empty'))stale[g.getAttribute('data-astra-bnpl-section')]=true;
  });
  Object.keys(stale).forEach(function(sid){
    if(!sid)return;
    fetch(cfg.url+'?section_id='+sid+'&variant='+variantId)
      .then(function(r){return r.ok?r.text():Promise.reject();})
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        doc.querySelectorAll('[data-astra-bnpl]').forEach(function(g){
          var id=g.getAttribute('data-astra-bnpl-id');
          var freshRow=g.querySelector('.astra-bnpl-row--shoppay');
          var liveG=document.querySelector('.astra-pdp [data-astra-bnpl][data-astra-bnpl-id="'+id+'"]');
          if(!id||!freshRow||!liveG)return;
          var liveRow=liveG.querySelector('.astra-bnpl-row--shoppay');
          if(!liveRow)return;
          liveRow.innerHTML=freshRow.innerHTML;
          liveRow.removeAttribute('data-astra-bnpl-empty');
        });
      })
      .catch(function(){});
  });
};
function openTrust(key){
  document.getElementById('tm-'+key).classList.add('show');document.body.style.overflow='hidden';
  if(key==='bnpl')window.astraRefreshBnpl(null,null,document.getElementById('tm-bnpl'));
}
function closeTrust(key){document.getElementById('tm-'+key).classList.remove('show');document.body.style.overflow=''}
/* the compare modal only renders when the product has compare_* metafield rows,
   so both of these have to tolerate it being absent */
function openCompareModal(btn){var m=document.getElementById('compareModal');if(!m)return;m.classList.add('show');document.body.style.overflow='hidden';if(btn&&btn.classList)btn.classList.add('kh-info-clicked')}
function closeCompareModal(){var m=document.getElementById('compareModal');if(!m)return;m.classList.remove('show');document.body.style.overflow=''}
/* _32 NEW - Care modal open/close, same pattern as compare modal above. */
function openCareModal(){document.getElementById('careModal').classList.add('show');document.body.style.overflow='hidden'}
function closeCareModal(){document.getElementById('careModal').classList.remove('show');document.body.style.overflow=''}

/* UGC video lightbox — plays the tapped strip video (src carried on the thumb's data-ugc-src). */
function openUgc(el){
  var src=el&&el.getAttribute('data-ugc-src');if(!src)return;
  var m=document.getElementById('ugcModal'),v=document.getElementById('ugcModalVideo');if(!m||!v)return;
  v.src=src;m.classList.add('show');document.body.style.overflow='hidden';
  var p=v.play();if(p&&p.catch)p.catch(function(){});
}
function closeUgc(){
  var m=document.getElementById('ugcModal'),v=document.getElementById('ugcModalVideo');if(!m||!v)return;
  v.pause();v.removeAttribute('src');v.load();
  m.classList.remove('show');document.body.style.overflow='';
}

/* price breakdown modal (#19) */

function qty(d){var el=document.getElementById('qtyv');el.value=Math.max(1,Math.min(10,(parseInt(el.value)||1)+d))}
/* v129: copy confirmation is a state on the pill, not an innerHTML swap.
   The old one-liner (kept below per never-delete convention) wrote
   "Copied ✓" into the 18px icon button, so the text overflowed the pill
   and collided with the label - it read as a glitch rather than a
   confirmation. Now the pill itself flips to a green "Copied" overlay
   (no reflow) and #pv2CopyStatus announces it to screen readers.
   Also falls back to execCommand when the async clipboard is blocked
   (non-secure context / permission denied), instead of silently
   showing success with nothing on the clipboard.
   v128 and earlier:
function copyCode(b){var code=b.getAttribute('data-code')||'PRIME10';if(navigator.clipboard)navigator.clipboard.writeText(code);var o=b.innerHTML;b.textContent='Copied ✓';setTimeout(function(){b.innerHTML=o},1600)}
*/
function astraLegacyCopy(text){
  try{
    var ta=document.createElement('textarea');
    ta.value=text;ta.setAttribute('readonly','');
    ta.style.cssText='position:fixed;top:-1000px;left:-1000px;opacity:0';
    document.body.appendChild(ta);ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    return true;
  }catch(e){return false}
}
function astraCopyText(text,onFail){
  if(navigator.clipboard&&navigator.clipboard.writeText){
    var p=navigator.clipboard.writeText(text);
    if(p&&p.then)p.then(null,function(){if(!astraLegacyCopy(text)&&onFail)onFail()});
    return;
  }
  if(!astraLegacyCopy(text)&&onFail)onFail();
}
function copyCode(b){
  var pill=b.classList&&b.classList.contains('pv2-code')?b:(b.closest?b.closest('.pv2-code'):null);
  if(!pill)pill=b;
  var code=((pill.getAttribute('data-code')||b.getAttribute('data-code')||'')+'').trim();
  if(!code)return;
  var status=document.getElementById('pv2CopyStatus');
  astraCopyText(code,function(){
    /* clipboard unavailable - keep the code selectable rather than claiming success */
    if(status)status.textContent='Could not copy automatically. Discount code is '+code+'.';
    pill.classList.remove('is-copied');
  });
  pill.classList.add('is-copied');
  if(status)status.textContent='Discount code '+code+' copied';
  if(pill._copyTimer)clearTimeout(pill._copyTimer);
  pill._copyTimer=setTimeout(function(){
    pill.classList.remove('is-copied');
    if(status)status.textContent='';
  },1700);
}
/* v130: the coupon is no longer mirrored from the DOM. The offer row and its
   accordion are server-rendered by snippets/astra-offers.liquid from the
   theme's own offer settings ("Static discount badges" + the category-level
   "Discount Tag list"), with the code read out of the offer copy itself, so
   there is nothing left to reconcile at runtime and no flash of a stale code
   before a sync lands. Kept per the never-delete convention.
   v129 and earlier - mirrored the countdown-timer banner in the header group,
   because that block lives in another section Liquid can't read:
function astraSyncCouponFromBanner(){
  var pill=document.querySelector('.astra-pdp .pv2-code');
  if(!pill)return;
  var srcCode=document.querySelector('.dicount_copy_code .code-text');
  var code=srcCode?(srcCode.textContent||'').trim():'';
  // the banner's own handler swaps this text to "Code Copied!" for 1.5s
  if(code&&!/copied/i.test(code)){
    var txt=pill.querySelector('.pv2-code-text');
    if(txt)txt.textContent=code;
    pill.setAttribute('data-code',code);
    pill.setAttribute('aria-label','Copy discount code '+code);
  }
  var pct=document.querySelector('.astra-pdp .pv2-offer-pct');
  var srcLabel=document.querySelector('.discount_code_wrp .disc_with_txt .contained-heading');
  if(pct&&srcLabel){
    var m=(srcLabel.textContent||'').match(/(\d+(?:[.,]\d+)?)\s*%/);
    if(m)pct.textContent=m[1]+'%';
  }
}
*/
function togglePayWidgets(el){
  var open=el.getAttribute('aria-expanded')==='true';
  el.setAttribute('aria-expanded',String(!open));
  var panel=document.getElementById('pv2Widgets');
  panel.hidden=open;
  /* Klarna/PayPal size from the container, so they can only lay out once the
     panel is actually visible - see astraRefreshBnpl */
  if(!open)window.astraRefreshBnpl(null,null,panel);
}
/* Variant swatch mockup - UI pattern only, see PRD note above .swatch-row in
   the HTML. Only toggles which chip is "active" (shows its name); does NOT
   swap gallery images, price, specs, or availability - we only have real
   assets for one finish. Production build needs this wired to real
   variant/catalogue data. */
function selectSwatch(btn){
  document.querySelectorAll('#swatchRow .swatch').forEach(function(s){s.classList.remove('active')});
  btn.classList.add('active');
  var val=btn.getAttribute('data-value');
  if(val!=null&&typeof astraSelectByValue==='function')astraSelectByValue(val);
}
/* 3-fit compare table: visible scroll-track + optional text hint, applied
   generically to any scroll container/table/track triplet so the same
   logic covers both the below-fold table and the modal's copy without
   duplicating code. Track/hint only shown if a 4th+ competitor actually
   exists (data-overflow marker) - with exactly 3 brand columns everything
   already fits and there's nothing to scroll to. Thumb width/position
   reflect genuine scroll proportion (indicative, not draggable). */
function cmpSetupScroll(scrollId,tableId,trackId,hintId){
  var scrollEl=document.getElementById(scrollId);
  var table=document.getElementById(tableId);
  var track=trackId?document.getElementById(trackId):null;
  var hint=hintId?document.getElementById(hintId):null;
  if(!scrollEl||!table)return;
  var hasOverflow=table.querySelector('thead th[data-overflow]');
  if(!hasOverflow){
    if(hint)hint.style.display='none';
    if(track)track.style.display='none';
    return;
  }
  var thumb=track?track.querySelector('.cmp-scrollthumb'):null;
  function update(){
    if(!thumb)return;
    var maxScroll=scrollEl.scrollWidth-scrollEl.clientWidth;
    if(maxScroll<=0){track.style.display='none';return}
    var visibleRatio=scrollEl.clientWidth/scrollEl.scrollWidth;
    var scrolledRatio=maxScroll>0?scrollEl.scrollLeft/maxScroll:0;
    thumb.style.width=(visibleRatio*100)+'%';
    var trackWidth=track.clientWidth;
    var thumbWidth=trackWidth*visibleRatio;
    thumb.style.transform='translateX('+(scrolledRatio*(trackWidth-thumbWidth))+'px)';
  }
  scrollEl.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update,{passive:true});
  update();
}
cmpSetupScroll('cmpScroll3','cmpTable3','cmpScrollTrack','cmpScrollHint3');
cmpSetupScroll('cmpScroll3Modal','cmpTable3Modal','cmpScrollTrackModal','cmpScrollHintModal');
function estDelivery(){var p=document.getElementById('pcode').value.trim();var r=document.getElementById('deres');if(!p){r.textContent='Enter a postcode to see your date.';r.classList.add('show');r.style.color='var(--ink-3)';return}r.innerHTML='✓ Pre-order - estimated arrival <b>late Sept</b> to <b>'+p.toUpperCase()+'</b>';r.classList.add('show');r.style.color='var(--green)'}
function acc(b){var open=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',String(!open));var body=b.parentElement.querySelector('.acc-body');body.classList.toggle('open',!open);
  /* the Finance accordion holds BNPL vendor widgets, which can only lay
     themselves out once the body is open - see astraRefreshBnpl */
  if(!open&&body.querySelector('[data-astra-bnpl]'))window.astraRefreshBnpl(null,null,body);}
// v128: toggleCouponAccordion() restored (was commented out in v127,
// now needed again since the coupon row is back to doubling as the
// accordion trigger, per explicit direction).
function toggleCouponAccordion(el){
  var panel=document.getElementById('pv2MoreOffers');
  if(!panel)return;
  var next=!panel.open;
  panel.open=next;
  el.setAttribute('aria-expanded',String(next));
}
function openSidebar(){document.getElementById('sidebarOverlay').classList.add('show');document.body.style.overflow='hidden'}
function closeSidebar(){document.getElementById('sidebarOverlay').classList.remove('show');document.body.style.overflow=''}
function switchCmpTab(btn,panelId){document.querySelectorAll('.cmp-tab').forEach(function(t){t.classList.remove('active')});document.querySelectorAll('.cmp-panel').forEach(function(p){p.classList.remove('active')});btn.classList.add('active');var panel=document.getElementById(panelId);if(panel)panel.classList.add('active')}

function fbtCalc(){
  var t=0,addable=0,checked=0;
  document.querySelectorAll('.astra-pdp .fbt-item input:checked').forEach(function(c){
    t+=parseInt(c.dataset.price,10)||0; checked++;
    if(c.getAttribute('data-variant-id'))addable++;
  });
  var totalEl=document.getElementById('fbtTotal');
  if(totalEl)totalEl.innerHTML=(typeof astraMoney==='function')?astraMoney(t):('£'+Math.round(t/100));
  var cta=document.getElementById('fbtCta');
  if(cta)cta.textContent=addable>0?('Add '+addable+' item'+(addable!==1?'s':'')+' to basket'):'Add to basket';
  var save=document.getElementById('fbtSave');
  if(save){var txt=(save.getAttribute('data-saving')||'').trim();
    if(txt&&checked>=2){save.textContent=txt;save.style.display='inline-block';}else{save.style.display='none';}}
}

/* ── Meet the Makers: auto-swipe loop (1,2,3,4,1,2,3,4...) when centered, hands off to user scroll on interaction ── */
(function(){
  var rail=document.getElementById('makersJourney');
  if(!rail)return;
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(reduce)return;
  var steps=rail.querySelectorAll('.mj-step');
  if(steps.length<2)return;

  var userInteracted=false,autoTimer=null,idx=0,inViewport=false;

  function isCentered(){
    var r=rail.getBoundingClientRect();
    var vh=window.innerHeight;
    var rCenter=r.top+r.height/2;
    return rCenter>vh*0.25 && rCenter<vh*0.75;
  }

  function stepWidth(){
    return steps[0].getBoundingClientRect().width + 12; /* card width + gap */
  }

  function goNext(){
    if(userInteracted||!inViewport)return;
    /* only meaningful when the rail actually overflows (mobile / narrow layouts) */
    if(rail.scrollWidth<=rail.clientWidth+4)return;
    idx=(idx+1)%steps.length;
    var maxScroll=rail.scrollWidth-rail.clientWidth;
    var target=idx===0?0:Math.min(maxScroll, idx*stepWidth());
    rail.scrollTo({left:target,behavior:'smooth'});
  }

  function startAuto(){
    stopAuto();
    autoTimer=setInterval(goNext,2600);
  }
  function stopAuto(){
    if(autoTimer){clearInterval(autoTimer);autoTimer=null}
  }

  function handleUserInteraction(){
    if(userInteracted)return;
    userInteracted=true;
    stopAuto();
  }
  rail.addEventListener('touchstart',handleUserInteraction,{passive:true});
  rail.addEventListener('wheel',handleUserInteraction,{passive:true});
  rail.addEventListener('mousedown',handleUserInteraction,{passive:true});

  function onScroll(){
    var wasIn=inViewport;
    inViewport=isCentered();
    if(inViewport&&!wasIn&&!userInteracted){
      startAuto();
    }else if(!inViewport&&wasIn){
      stopAuto();
    }
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  onScroll();
})();

/* _39 NEW - Features/Benefits scrollytelling controller. Uses
   IntersectionObserver (not scroll-position math like the parallax
   engine below) since this only needs discrete on/off states per
   step, not continuous depth values. rootMargin centres the trigger
   line in the middle of the viewport rather than the default
   top/bottom edges. */
(function(){
  var steps=[].slice.call(document.querySelectorAll('.fb-step'));
  if(!steps.length)return;
  var callouts=[].slice.call(document.querySelectorAll('.fb-callout'));
  var benImg=document.getElementById('fbBenImg');
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;

  if(reduce){
    steps.forEach(function(s){ s.classList.add('is-active'); });
    callouts.forEach(function(c){ c.classList.add('is-shown'); });
    if(benImg)benImg.classList.add('is-shown');
    return;
  }

  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      var step=entry.target;
      if(entry.isIntersecting){
        step.classList.add('is-active');
        var key=step.dataset.fbStep;
        if(key==='combine'){
          callouts.forEach(function(c){ c.classList.add('is-shown'); });
        }
        if(key==='ben2'&&benImg){
          benImg.classList.add('is-shown');
        }
      }
    });
  },{ rootMargin:'-40% 0px -40% 0px', threshold:0 });

  steps.forEach(function(s){ io.observe(s); });
})();

/* _40 NEW - vertical-strip carousel controller (Features/Benefits).
   Simple single-open accordion per group: clicking a strip's trigger
   closes whichever strip in that same group is currently open and
   opens the clicked one. Clicking the already-open strip is a no-op
   (there is always exactly one open strip per group - never zero,
   per the "one pre-opened" direction). Keyboard-operable for free
   since triggers are real <button> elements.
   _43 FIX: the _42 version waited ~580ms (until the expand animation
   finished) before scrolling to center - which visibly looked like
   "expand off-screen, THEN jump to center" per explicit feedback.
   Fixed by computing the scroll target BEFORE toggling the open
   class and starting the scroll in the same tick as the expand
   transition, so both animate together and it reads as "centers
   itself as it opens," not two separate steps. The math: .vstrip-
   panel-inner's scrollHeight reports its natural (uncapped) content
   height even while the panel is still visually collapsed via max-
   height clipping - that's a real DOM behaviour (scrollHeight always
   reflects content, independent of the parent's own height/max-
   height), not a guess - so we know the FINAL expanded content
   height up front, without waiting for the animation to actually
   reach it. Also has to account for the PREVIOUSLY open strip in the
   same group closing at the same time - if it sits above the one
   being clicked, its collapse pulls everything below it (including
   the clicked strip) upward by its own content height, and skipping
   that correction was the actual bug in the first attempt at this
   fix (it overshot by roughly the closing strip's height). Desktop
   is deliberately skipped: the row's height is fixed whether a strip
   is open or closed there (only its width flexes), so nothing ever
   moves vertically on desktop - there's nothing to correct. */
(function(){
  var groups=[].slice.call(document.querySelectorAll('[data-vstrip-group]'));
  if(!groups.length)return;
  groups.forEach(function(group){
    var strips=[].slice.call(group.querySelectorAll('[data-vstrip]'));
    strips.forEach(function(strip){
      var trigger=strip.querySelector('.vstrip-trigger');
      if(!trigger)return;
      trigger.addEventListener('click',function(){
        if(strip.classList.contains('is-open'))return;
        if(window.innerWidth<820){
          var prevOpen=strips.filter(function(s){return s!==strip&&s.classList.contains('is-open');})[0];
          var prevOpenH=0,prevIsBefore=false;
          if(prevOpen){
            var prevInner=prevOpen.querySelector('.vstrip-panel-inner');
            prevOpenH=prevInner?prevInner.scrollHeight:0;
            prevIsBefore=!!(prevOpen.compareDocumentPosition(strip)&Node.DOCUMENT_POSITION_FOLLOWING);
          }
          var panelInner=strip.querySelector('.vstrip-panel-inner');
          var triggerRect=trigger.getBoundingClientRect();
          var myContentH=panelInner?panelInner.scrollHeight:0;
          var vh=window.innerHeight;
          var adjustedBottom=triggerRect.bottom-(prevIsBefore?prevOpenH:0);
          var contentCenter=adjustedBottom+myContentH/2;
          window.scrollBy({top:contentCenter-vh/2,behavior:'smooth'});
        }
        strips.forEach(function(s){
          s.classList.remove('is-open');
          var t=s.querySelector('.vstrip-trigger');
          if(t)t.setAttribute('aria-expanded','false');
        });
        strip.classList.add('is-open');
        trigger.setAttribute('aria-expanded','true');
      });
    });
  });
})();

/* _50m NEW - icon-blend card controller (Features/Benefits). Auto-
   cycles through the icon+label columns so all of them surface without
   a click; clicking a column jumps to it directly and restarts the
   cycle. No pins on the photo itself - the cycle lives in the row
   only, per explicit direction.
   _53 UPDATE: now also drives .ibc-caption (the old tag pill's spot,
   removed per explicit direction) - each column's data-copy attribute
   supplies a one-line supporting claim that swaps in sync with the
   active icon, so the card carries a real supporting sentence instead
   of a bare 1-2 word label + a static tag.
   _27 FIX: previously every icon-blend-card on the page auto-cycled
   continuously regardless of whether its slide was the one actually
   visible in the carousel - so swiping to a different tile showed a
   caption already mid-cycle (or fading) instead of starting fresh,
   which read as random/distracting. Cards now expose start()/stop()
   (as card._ibcStart / card._ibcStop) and stay paused-on-icon-0 until
   the carousel engine below tells them their slide became active.
   _39 NEW - static-caption mode: a card with a [data-static-caption]
   attribute (Build+Long-Lasting, Finish+Unique) skips cycling entirely
   - both icons stay marked active together and the caption is set once
   from that attribute instead of swapping between each icon's own
   data-copy. Per explicit direction: two claims merged into one
   sentence and shown permanently, same pattern Lifestyle's single
   fixed caption already uses, rather than one icon's text switching
   to the other's. */
(function(){
  var cards=[].slice.call(document.querySelectorAll('.icon-blend-card'));
  cards.forEach(function(card){
    var staticCaption=card.getAttribute('data-static-caption');
    var captionText=card.querySelector('.ibc-caption-text');
    if(staticCaption){
      /* static mode: no cycling, nothing to start/stop - all icons
         already carry .active in the HTML, just set the caption once. */
      if(captionText){
        captionText.textContent=staticCaption;
        captionText.style.opacity=1;
      }
      card._ibcStart=function(){};
      card._ibcStop=function(){};
      return;
    }
    var cols=[].slice.call(card.querySelectorAll('.ibc-col'));
    if(!cols.length)return;
    /* _26 FIX: target the inner .ibc-caption-text span, not the outer
       .ibc-caption box - the outer box also renders the divider line
       (border-top), which was fading in/out along with the text since
       opacity was toggled on the whole box. Now only the text node
       fades; the line stays static/always visible. */
    var i=0,timer,fadeTimer;
    function show(n,skipFade){
      i=n;
      cols.forEach(function(c,k){c.classList.toggle('active',k===i)});
      if(captionText){
        clearTimeout(fadeTimer);
        if(skipFade){
          captionText.textContent=cols[i].getAttribute('data-copy')||'';
          captionText.style.opacity=1;
        }else{
          captionText.style.opacity=0;
          fadeTimer=setTimeout(function(){
            captionText.textContent=cols[i].getAttribute('data-copy')||'';
            captionText.style.opacity=1;
          },300);
        }
      }
    }
    function restart(){
      clearInterval(timer);
      /* _28 FIX: single-icon cards (e.g. Real Storage) have nothing to
         cycle TO - the interval was calling show() on the same icon
         every 2400ms regardless, which meant a pointless fade-out/
         fade-in of identical text. No cycle at all when there's only
         one option. */
      if(cols.length<=1)return;
      if(matchMedia('(prefers-reduced-motion:reduce)').matches)return;
      timer=setInterval(function(){show((i+1)%cols.length)},2400);
    }
    function stop(){
      clearInterval(timer);
      clearTimeout(fadeTimer);
    }
    cols.forEach(function(c,idx){
      c.addEventListener('click',function(){show(idx,cols.length<=1);restart();});
    });
    var inCarousel=!!card.closest('.fb-carousel');
    show(0,true);
    if(!inCarousel)restart();
    /* exposed for the fb-carousel engine to call on slide activate/deactivate */
    card._ibcStart=function(){show(0,true);restart();};
    card._ibcStop=stop;
  });
})();

/* lightweight scroll parallax for [data-depth] layers (reduced-motion safe) */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var els=[].slice.call(document.querySelectorAll('[data-depth]'));
  if(reduce||!els.length)return;
  var coarse=matchMedia('(pointer:coarse)').matches,ticking=false;
  function frame(){
    var vh=innerHeight;
    els.forEach(function(el){
      var story=el.closest('.parallax-story')||el;
      var r=story.getBoundingClientRect();
      if(r.bottom<-160||r.top>vh+160)return;
      var progress=Math.max(-1,Math.min(1,(r.top+r.height/2-vh/2)/vh));
      var depth=(parseFloat(el.dataset.depth)||0)*(coarse?0.6:1);
      var rot=parseFloat(el.dataset.rotate)||0;
      var y=(-progress*depth*vh*1.1).toFixed(1);
      var x=(progress*depth*32).toFixed(1);
      var rr=(rot+progress*depth*9).toFixed(2);
      var base=el.classList.contains('px-card--hero')?'translate(-50%,-50%) ':'';
      el.style.transform=base+'translate3d('+x+'px,'+y+'px,0) rotate('+rr+'deg)';
    });
    ticking=false;
  }
  function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(frame);}}
  addEventListener('scroll',onScroll,{passive:true});
  addEventListener('resize',onScroll,{passive:true});
  frame();
})();

/* v94: MOSAIC GRID REVEAL engine RESTORED - per explicit request
   ("the grid animation is gone bro"), reversing the v93 removal that
   followed the content review's "not scroll-driven" note. Reversible
   scroll-position trigger (scrollY >= trigger), not a one-way entrance
   animation - each cell's slide/fade direction comes from its own
   data-dir attribute in the HTML. */
(function(){
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var cells=[].slice.call(document.querySelectorAll('.mosaic-cell, .vstrip'));
  if(!cells.length)return;
  if(reduce){
    cells.forEach(function(c){c.classList.add('is-visible');});
    return;
  }
  var triggers=[];
  function measure(){
    var saved=cells.map(function(el){
      var s={transform:el.style.transform,transition:el.style.transition};
      el.style.transition='none';
      el.style.transform='none';
      return s;
    });
    triggers=cells.map(function(el){
      var rect=el.getBoundingClientRect();
      return {el:el,y:rect.top+window.scrollY-window.innerHeight*0.85};
    });
    cells.forEach(function(el,i){
      el.style.transform=saved[i].transform;
      el.style.transition=saved[i].transition;
    });
  }
  var mTicking=false;
  function mUpdate(){
    mTicking=false;
    var y=window.scrollY;
    triggers.forEach(function(t){
      var show=y>=t.y;
      if(t.el.classList.contains('vstrip')){
        /* _44 FIX: Features/Benefits strips should never fade back
           OUT once revealed - explicit "no exit animations" direction.
           This also fixes a real interaction bug: the _43 auto-center
           scroll (opening a strip smooth-scrolls the page) could
           itself cross back above this same reveal trigger line,
           which under the old reversible toggle would immediately
           hide the very strip being centered into view. One-way
           reveal removes that failure mode entirely, not just the
           visual preference. The bento grid below keeps the original
           reversible behaviour - this only touches .vstrip. */
        if(show)t.el.classList.add('is-visible');
      }else{
        t.el.classList.toggle('is-visible',show);
      }
    });
  }
  function onMosaicScroll(){if(!mTicking){mTicking=true;requestAnimationFrame(mUpdate);}}
  window.addEventListener('scroll',onMosaicScroll,{passive:true});
  window.addEventListener('resize',function(){measure();mUpdate();});
  measure();
  mUpdate();
  /* v94 BUGFIX: this page has a layout shift that continues for a bit
     after initial script execution (fonts/images/other engines on the
     page settling), which throws off trigger positions computed too
     early - cells would need far more scroll than intended, or never
     reveal within a reasonable range. Re-measuring on window 'load'
     and once more after a short delay catches that settling without
     needing to know its exact cause. */
  window.addEventListener('load',function(){measure();mUpdate();});
  setTimeout(function(){measure();mUpdate();},1500);
})();

/* _32 NEW - THE CRAFT carousel (fan/stack motion). Independent of the
   mosaic reveal engine above - that system only decides WHEN a cell
   fades in via scroll position; this system decides each craft slide's
   own transform/opacity/blur based on distance from the active index,
   restyled from the provided reference (orange -> bronze/dark) per
   explicit direction. Auto-advances, pauses on manual interaction,
   and skips the blur/scale motion for prefers-reduced-motion (opacity
   crossfade only, matching how the rest of this file already handles
   reduced motion). */
(function(){
  var track=document.getElementById('craftTrack');
  if(!track)return;
  var slides=[].slice.call(track.querySelectorAll('.craft-slide'));
  var dotsWrap=document.getElementById('craftDots');
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var active=0, autoTimer=null;

  slides.forEach(function(s,i){
    var d=document.createElement('div');
    d.className='craft-dot'+(i===0?' active':'');
    d.setAttribute('aria-label','Go to step '+(i+1));
    d.addEventListener('click',function(){goTo(i,true);});
    dotsWrap.appendChild(d);
  });
  var dots=[].slice.call(dotsWrap.querySelectorAll('.craft-dot'));

  function render(){
    slides.forEach(function(s,i){
      var offset=i-active;
      // wrap offset to the shortest direction around the 4 slides
      if(offset>slides.length/2)offset-=slides.length;
      if(offset<-slides.length/2)offset+=slides.length;
      var abs=Math.abs(offset);
      var tx=offset*(reduce?0:62), scale=1-abs*0.14, op=abs===0?1:(abs===1?0.55:0);
      var blur=reduce?0:Math.min(abs*3,6);
      s.style.transform='translateX(-50%) translateX('+tx+'%) scale('+Math.max(scale,0.7)+')';
      s.style.filter=blur?'blur('+blur+'px)':'none';
      s.style.setProperty('--craft-op',op);
      s.style.zIndex=String(10-abs);
      s.style.pointerEvents=abs===0?'auto':'none';
    });
    dots.forEach(function(d,i){d.classList.toggle('active',i===active);});
  }
  function goTo(i,manual){
    active=(i+slides.length)%slides.length;
    render();
  }
  window.craftGo=function(dir){ goTo(active+dir,true); };
  /* _64 FIX: auto-rotate removed per explicit direction - the Craft
     carousel now only advances on user action (arrows, dots, swipe/
     drag), same as the Pillars carousel already does. restartAuto()
     is left in place, unused, per the never-delete convention (in
     case a future direction wants it back) - it's simply no longer
     called from goTo() or on init below. */
  function restartAuto(){
    if(autoTimer)clearInterval(autoTimer);
    if(reduce)return;
    autoTimer=setInterval(function(){ goTo(active+1,false); },4500);
  }

  /* _34 NEW - swipe/drag support, same nav (goTo) the arrow buttons
     and dots already use. Pointer Events cover touch, mouse, and pen
     in one listener set rather than separate touchstart/mousedown
     handlers. A small drag-distance threshold (40px) avoids
     accidentally triggering a slide change on an ordinary tap. */
  var dragStartX=null, dragDeltaX=0, dragging=false;
  track.addEventListener('pointerdown',function(e){
    dragging=true; dragStartX=e.clientX; dragDeltaX=0;
    track.setPointerCapture(e.pointerId);
  });
  track.addEventListener('pointermove',function(e){
    if(!dragging)return;
    dragDeltaX=e.clientX-dragStartX;
  });
  function endDrag(){
    if(!dragging)return;
    dragging=false;
    if(Math.abs(dragDeltaX)>40){ goTo(active+(dragDeltaX<0?1:-1),true); }
    dragDeltaX=0;
  }
  track.addEventListener('pointerup',endDrag);
  track.addEventListener('pointercancel',endDrag);
  track.addEventListener('pointerleave',function(){ if(dragging)endDrag(); });

  render();
})();

/* _49-carousel-variant NEW - FEATURES/BENEFITS FAN/STACK CAROUSEL
   ENGINE. Same motion math as the Craftsmanship carousel above
   (translateX/scale/blur by distance-from-active), but written as a
   reusable initializer that runs once per .fb-carousel found on the
   page, each with its own closure-scoped state (active index, slides,
   dots, drag state, autoplay timer). This is what let two independent
   instances (Features, Benefits) exist on one page without the
   hardcoded-single-instance problem the craft carousel's own code has
   (one #craftTrack id, one global craftGo, one shared "active"
   variable) - see the top-of-file changelog entry for the full
   reasoning. Nav buttons use data-fb-nav="-1"/"1" + a real listener
   instead of an inline onclick calling a global function, since there
   is no single global function here - each instance's buttons are
   wired to that instance's own goTo(). */
(function(){
  var roots=[].slice.call(document.querySelectorAll('.fb-carousel'));
  if(!roots.length)return;
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;

  roots.forEach(function(root){
    var track=root.querySelector('.fb-track');
    if(!track)return;
    var slides=[].slice.call(track.querySelectorAll('.fb-slide'));
    if(!slides.length)return;
    var dotsWrap=root.querySelector('.fb-dots');
    var active=0, prevActive=-1;

    slides.forEach(function(s,i){
      var d=document.createElement('div');
      d.className='fb-dot'+(i===0?' active':'');
      d.setAttribute('aria-label','Go to item '+(i+1));
      d.addEventListener('click',function(){ goTo(i,true); });
      if(dotsWrap)dotsWrap.appendChild(d);
    });
    var dots=dotsWrap?[].slice.call(dotsWrap.querySelectorAll('.fb-dot')):[];

    function render(){
      slides.forEach(function(s,i){
        var offset=i-active;
        if(offset>slides.length/2)offset-=slides.length;
        if(offset<-slides.length/2)offset+=slides.length;
        var abs=Math.abs(offset);
        var tx=offset*(reduce?0:62), scale=1-abs*0.14, op=abs===0?1:(abs===1?0.55:0);
        var blur=reduce?0:Math.min(abs*3,6);
        s.style.transform='translateX(-50%) translateX('+tx+'%) scale('+Math.max(scale,0.7)+')';
        s.style.filter=blur?'blur('+blur+'px)':'none';
        s.style.setProperty('--fb-op',op);
        s.style.zIndex=String(10-abs);
        s.style.pointerEvents=abs===0?'auto':'none';
      });
      dots.forEach(function(d,i){ d.classList.toggle('active',i===active); });
      /* _27 ADD: only the actually-visible slide's icon-blend-card
         should be auto-cycling - start the newly-active one fresh
         (from icon 0) and stop whichever one just left, instead of
         every card in the carousel cycling non-stop in the
         background regardless of visibility. */
      if(active!==prevActive){
        if(prevActive>-1){
          var prevCard=slides[prevActive]&&slides[prevActive].querySelector('.icon-blend-card');
          if(prevCard&&prevCard._ibcStop)prevCard._ibcStop();
        }
        var curCard=slides[active]&&slides[active].querySelector('.icon-blend-card');
        if(curCard&&curCard._ibcStart)curCard._ibcStart();
        prevActive=active;
      }
    }
    function goTo(i,manual){
      active=(i+slides.length)%slides.length;
      render();
    }

    [].slice.call(root.querySelectorAll('[data-fb-nav]')).forEach(function(btn){
      btn.addEventListener('click',function(){
        goTo(active+parseInt(btn.getAttribute('data-fb-nav'),10),true);
      });
    });

    var dragStartX=null, dragDeltaX=0, dragging=false;
    track.addEventListener('pointerdown',function(e){
      dragging=true; dragStartX=e.clientX; dragDeltaX=0;
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove',function(e){
      if(!dragging)return;
      dragDeltaX=e.clientX-dragStartX;
    });
    function endDrag(){
      if(!dragging)return;
      dragging=false;
      if(Math.abs(dragDeltaX)>40){ goTo(active+(dragDeltaX<0?1:-1),true); }
      /* _59 ADD: remember if this pointer interaction actually moved a
         meaningful distance, so the card-lightbox click handler can
         ignore the click that fires at the end of a drag (otherwise a
         swipe to change slides would also pop the lightbox open). */
      track._fbDragged=Math.abs(dragDeltaX)>8;
      setTimeout(function(){track._fbDragged=false;},0);
      dragDeltaX=0;
    }
    track.addEventListener('pointerup',endDrag);
    track.addEventListener('pointercancel',endDrag);
    track.addEventListener('pointerleave',function(){ if(dragging)endDrag(); });

    /* fade in with the same scroll-reveal engine the rest of the page
       uses, one-way (no exit) same as the vstrip carousel this is
       replacing - simplest approach here: reveal on first scroll into
       view via IntersectionObserver, since this carousel manages its
       own per-slide opacity already (--fb-op) same as craft does. */
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          slides.forEach(function(s){ s.classList.add('is-visible'); });
          io.disconnect();
        }
      });
    },{ threshold:0.2 });
    io.observe(root);

    render();
  });
})();

/* _70 NEW - measures the header's own actual rendered bottom edge
   (announce+header stacked, whatever their real combined height is)
   and sets --secnav-top to that exact value, so .secnav's sticky
   freeze point is a hard guarantee, not an assumption baked into a
   hardcoded top:92px. Re-measures on load, on resize (announce/
   header height can differ across breakpoints), and once more after
   a short delay to catch web-font swap reflow. */
(function(){
  /* Astra chrome was dropped; measure the THEME header (store-header.header)
     instead. --secnav-top tracks the header's on-screen bottom edge, clamped
     to its height, so secnav freezes just below a sticky header and pins to
     the viewport top once a non-sticky header scrolls away. Works on desktop
     and mobile; recomputed on scroll (header may shrink), resize and load. */
  /* Scan every header/announcement candidate and take the lowest edge of
     whatever is actually FIXED/STICKY and pinned at the very top right now
     (the theme stacks announcement-bar + store-header, and the pinned node
     may be a child). That bottom edge is exactly where secnav must freeze so
     it never slides underneath. Falls to 0 when nothing is pinned. */
  var CANDS='store-header,.header,announcement-bar,.cc-announcement,.section-header,[data-is-sticky],header';
  /* _71: the secnav is pinned via position:fixed (.is-pinned), NOT position:sticky.
     The sections it links to (#finish…#reviews) were split into separate sibling
     sections, leaving .secnav's parent (.astra-pdp) too short for a sticky element
     to travel in - it only had ~48px of sticky range and scrolled away instantly.
     The spacer reserves the nav's height in flow while it's pinned (no jump), and
     the nav hides once the last navigable section has scrolled up past it. */
  var secnavEl=document.querySelector('.secnav');
  var spacer=document.getElementById('secnavSpacer');
  var pinned=false;
  function lastNavSection(){
    var links=secnavEl?secnavEl.querySelectorAll('a'):[];
    if(!links.length)return null;
    var t=document.querySelector(links[links.length-1].getAttribute('href'));
    if(!t)return null;
    return t.closest('[id^="shopify-section-"]')||t;
  }
  function updatePin(topPx){
    if(!secnavEl||!spacer)return;
    var navH=secnavEl.offsetHeight;
    /* slot = where the nav sits in normal flow: the nav itself while unpinned,
       the spacer (which reserves navH) once pinned. Compared against the header's
       bottom edge (topPx) - the point the nav must freeze at. */
    var slotTop=(pinned?spacer:secnavEl).getBoundingClientRect().top;
    if(!pinned){
      if(slotTop<=topPx){ spacer.style.height=navH+'px'; secnavEl.classList.add('is-pinned'); pinned=true; }
    } else if(slotTop>=topPx+1){ /* 1px hysteresis so the boundary doesn't flicker */
      secnavEl.classList.remove('is-pinned','is-hidden'); spacer.style.height='0px'; pinned=false;
    }
    if(pinned){
      if(spacer.offsetHeight!==navH) spacer.style.height=navH+'px'; /* keep in sync across breakpoints */
      var ls=lastNavSection();
      secnavEl.classList.toggle('is-hidden', !!ls && ls.getBoundingClientRect().bottom<=topPx+navH);
    }
  }
  function setSecnavTop(){
    var vh=window.innerHeight||800, off=0, els=document.querySelectorAll(CANDS);
    for(var i=0;i<els.length;i++){
      var el=els[i]; if(!el.offsetHeight)continue;
      /* Skip chrome that isn't actually on screen. The theme's closed drawers
         (cart, mobile menu, quick-add) each contain a `header.drawer__header`
         that matches CANDS, sits at rectTop 0 and is 57-61px tall - taller than
         the real 56px sticky header. Counting those pushed --secnav-top to 61px
         and left a ~5px strip of page background between the header and the
         pinned secnav. They are visibility:hidden (which inherits, so the
         computed value is 'hidden' on the drawer header itself), so one
         visibility/opacity check is enough to exclude the whole family. */
      var cs=getComputedStyle(el);
      if(cs.visibility!=='visible'||parseFloat(cs.opacity)===0)continue;
      /* ...and never measure drawer/modal chrome even while it IS open (an open
         cart drawer would otherwise be visible at rectTop 0 and leave the same
         stale offset behind after it closes). The page header is not inside one. */
      if(el.closest('.drawer,dialog,[role="dialog"],modal-dialog'))continue;
      /* Take the lowest bottom edge of any header/announcement element that is
         currently sitting against the top of the viewport. No position check:
         this theme keeps store-header itself position:relative and makes a
         wrapper sticky, so the header stays pinned (rectTop ~ announcement
         height) while its computed position is 'relative'. Measuring the
         bottom edge works regardless of which node owns the sticky. */
      var r=el.getBoundingClientRect();
      if(r.bottom>off && r.bottom>0 && r.top<vh*0.4 && r.bottom<vh*0.5) off=r.bottom;
    }
    /* floor (not round) the header's bottom edge: a fractional bottom (common on
       HiDPI / with the announcement bar) rounded UP would freeze the secnav below
       the header, exposing a sub-pixel line of page background - the tiny gap.
       Flooring makes the secnav tuck flush under the header, never leaving a gap. */
    var topPx=Math.max(0,Math.floor(off));
    document.documentElement.style.setProperty('--secnav-top', topPx+'px');
    updatePin(topPx);
  }
  setSecnavTop();
  var ticking=false;
  function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(function(){ ticking=false; setSecnavTop(); }); } }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',setSecnavTop,{passive:true});
  window.addEventListener('load',setSecnavTop);
  setTimeout(setSecnavTop,500); setTimeout(setSecnavTop,1200);
})();
/* In-page anchor jumps - the secnav tabs and the rating row's review-count link.
   Native #hash navigation resolves the target's position ONCE, at click time.
   This page keeps shifting below the fold after that: lazy images settle to their
   real height, the secnav spacer claims its 48px the moment the nav pins, and the
   app sections (LimeSpot, Judge.me) fill in. So the target slides further down
   while the jump is still in flight and the browser never re-aims - measured on
   the Reviews tab AND the rating row's count link, both landed ~950px short of
   #reviews, i.e. a whole screen up in the testimonials/FAQ stretch.
   html{scroll-padding-top} already handles the sticky-header offset correctly;
   it is the post-jump drift that breaks it. So own the jump: scroll there, then
   keep re-aiming for as long as the target keeps moving, and bail out the instant
   the visitor scrolls themselves so we never fight their input. */
/* secnavJumping: true for as long as a click-triggered jump() below is still
   steering the scroll (see WATCH_MS/stop() in jump()). The scroll listener
   further down recalculates the active secnav tab from the live scroll
   position on every scroll event, which - left unchecked - fights the
   instant active-on-click state while the smooth-scroll animation is still
   passing through intermediate sections, so the highlight flickers back to
   whatever section is passing by and only settles once scrolling stops.
   Suppressing that recalculation while a jump is in flight makes the
   click-time highlight actually stick. */
var secnavJumping=false;
/* Live sticky-header+secnav clearance (--secnav-top + 56px, see astra-pdp.liquid's
   html{scroll-padding-top:...}) - shared by jump()'s landing spot below AND the
   active-section scroll listener further down, so "where a click lands" and
   "when a section counts as reached" always agree. They used to be two
   independent numbers (this pad vs. a hardcoded 130 in the scroll listener);
   whenever the live pad grew past 130 - pinned header taller, announcement bar,
   different breakpoint - a click would land a few px short of the threshold,
   so the tab only activated once the visitor nudged the page those extra px
   themselves. */
function scrollPad(){return parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop)||0}
(function(){
  var WATCH_MS=1500,TICK_MS=100,GIVE=['wheel','touchstart','keydown'];
  function targetTop(el){
    return Math.max(0,Math.round(el.getBoundingClientRect().top+window.scrollY-scrollPad()));
  }
  function jump(el,secIdx){
    secnavJumping=true;
    var aim=targetTop(el),t0=Date.now(),iv;
    /* _72 FIX: this used to compare targetTop(el) (which bakes in scrollPad())
       between ticks, so it re-issued scrollTo() whenever the PAD changed - not
       just when the target's own content position changed. scrollPad() itself
       shifts within the first frames of almost every downward jump from the
       top of the page, because --secnav-top's measurement includes the
       announcement bar only while it's still on screen (see setSecnavTop()
       above): the instant our own scroll starts and the bar scrolls out of
       view, the pad shrinks. That pad-only change was being mistaken for
       "the target drifted", restarting the smooth-scroll animation seconds
       into every jump - the visible jitter, and (by extending/derailing the
       animation) the reason the wrong tab sometimes ended up active. Content
       drift (the ORIGINAL intent - lazy images etc. reflowing the target's
       own position) is what should still trigger a re-aim; a pad-only shift
       should not, since aim is naturally recomputed via targetTop() below. */
    var elTop=docTop(el);
    function stop(){secnavJumping=false;clearInterval(iv);GIVE.forEach(function(ev){window.removeEventListener(ev,stop)})}
    GIVE.forEach(function(ev){window.addEventListener(ev,stop,{passive:true})});
    window.scrollTo({top:aim,behavior:'smooth'});
    iv=setInterval(function(){
      if(Date.now()-t0>WATCH_MS){
        stop();
        /* natural completion, not a manual bail-out (GIVE never fired) - now
           that scrollPad() has settled, re-assert the tab this jump was
           actually for. The landing position can still end up a touch short
           of the scroll listener's own arrival threshold below (it was
           computed from aim's click-time pad, which can be a little larger
           than the now-settled one - see the note above), which would
           otherwise let the highlight slip back to the previous tab the
           moment the visitor scrolls again even slightly. We know
           definitively which section this was for, so don't leave that
           outcome to the position heuristic. Skipped on a manual bail-out
           (see GIVE below) so we still never fight the visitor's own scroll. */
        if(secIdx!=null&&secIdx>-1&&navlinks[secIdx]){
          lastIdx=secIdx;
          navlinks.forEach(function(nl,ni){nl.classList.toggle('active',ni===secIdx)});
        }
        return;
      }
      var curTop=docTop(el);
      /* only re-issue when the target itself has moved in the document, so a
         settled page (and a settling sticky offset) costs nothing and we
         don't interrupt the in-flight smooth scroll */
      if(Math.abs(curTop-elTop)>2){elTop=curTop;aim=targetTop(el);window.scrollTo({top:aim,behavior:'smooth'})}
    },TICK_MS);
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href^="#"]');
    /* scoped to this template's own nav/rating anchors - leaves the header's
       skip-link and any app-owned #hash links on native behaviour */
    if(!a||!a.closest('.astra-pdp, .secnav'))return;
    var id=a.getAttribute('href').slice(1);
    if(!id)return;
    var el=document.getElementById(id);
    if(!el)return;
    e.preventDefault();
    if(history.pushState)history.pushState(null,'','#'+id);
    /* secnav tabs: don't wait for the scroll listener below to catch up with
       the in-flight smooth scroll (that's what caused the active tab to lag
       until the page had already scrolled a bit) - we already know exactly
       which section was targeted, so light it up right away. The scroll
       listener still runs as the page settles and will agree with this. */
    var secIdx=a.closest('.secnav')?secs.indexOf(el):-1;
    if(secIdx>-1){
      lastIdx=secIdx;
      navlinks.forEach(function(nl,ni){nl.classList.toggle('active',ni===secIdx)});
      centerNav(navlinks[secIdx]);
    }
    jump(el,secIdx);
  });
})();
var navlinks=[].slice.call(document.querySelectorAll('.secnav a'));
var secs=navlinks.map(function(a){return document.querySelector(a.getAttribute('href'))});
var secnavIn=document.querySelector('.secnav-in'),lastIdx=-1;
function centerNav(a){
  if(!a||!secnavIn)return;
  /* v-branch BUGFIX: was a.scrollIntoView({block:'nearest',inline:'nearest'}) -
     block:'nearest' lets the browser also decide to scroll the whole PAGE
     vertically if it thinks the element isn't "visible enough", which is
     exactly what was causing an unexpected big vertical jump on the very
     first scroll (the moment the active section first changes from none
     to the first one). This nav is only meant to scroll horizontally, so
     scroll the .secnav-in container's scrollLeft directly instead of
     using scrollIntoView at all - it can no longer touch vertical scroll. */
  var target=a.offsetLeft-(secnavIn.clientWidth/2)+(a.clientWidth/2);
  secnavIn.scrollTo({left:target,behavior:'smooth'});
}
/* _60/_69 history: earlier attempts at this logic are kept below for
   context, but per explicit clarification the ACTUAL desired
   behaviour is: each tab stays active continuously from when its own
   section starts until the NEXT section (in page order) starts -
   including through stretches like the Craft carousel that have no
   nav entry of their own. Specs should persist all the way to Fair
   Pricing, not fall back to Overview in between.
   _69 already fixed the real underlying bug (offsetTop being
   relative to a positioned ancestor rather than the document) using
   getBoundingClientRect()+scrollY - that part stays. What changes
   here is just which section "wins": instead of only matching within
   a section's own [top, top+height) range, find whichever section
   has the LARGEST document-relative top that's still <= the current
   scroll position - i.e. the closest preceding section. That
   section then stays active for the entire stretch until the next
   one's top is reached, which is exactly the desired behaviour and
   also naturally handles Overview activating once you scroll past
   its own anchor (#finish) and before Specs begins. */
function docTop(el){ return el.getBoundingClientRect().top+window.scrollY; }
window.addEventListener('scroll',function(){
  if(secnavJumping)return;
  var y=window.scrollY+scrollPad(),idx=0,best=-Infinity;
  for(var i=0;i<secs.length;i++){
    var s=secs[i];
    if(!s)continue;
    var top=docTop(s);
    if(y>=top&&top>best){ best=top; idx=i; }
  }
  navlinks.forEach(function(a,i){a.classList.toggle('active',i===idx)});
  if(idx!==lastIdx){lastIdx=idx;centerNav(navlinks[idx])}
},{passive:true});

var consentOpen=true;
function closeConsent(){window.consentDismissed=true;document.getElementById('consent').classList.add('hide');var bd=document.getElementById('consentBackdrop');if(bd)bd.classList.remove('show');consentOpen=false}
var exitShown=false;

function openExit(manual){
  if(!manual&&(exitShown||consentOpen))return;
  exitShown=true;

  /* ── Dynamic product image injection ──────────────────────────────────
     Reads the currently active gallery image. Skips bg:false slides
     (lifestyle/reviews) and picks the first product shot instead.
     Falls back to the lifestyle image if nothing else is available.
     On Shopify this becomes: read product.featured_image via Liquid,
     then swap with JS on popup open  -  same logic, different source.
  ──────────────────────────────────────────────────────────────────── */
  var exitImg=document.getElementById('exitImg');
  if(exitImg&&typeof imgs!=='undefined'){
    /* prefer current slide if it's a product shot */
    var candidate=imgs[gi]&&imgs[gi].bg?imgs[gi]:null;
    /* otherwise find first product shot in the array */
    if(!candidate){
      for(var k=0;k<imgs.length;k++){
        if(imgs[k].bg){candidate=imgs[k];break;}
      }
    }
    /* fallback: use first image regardless */
    if(!candidate)candidate=imgs[0];
    exitImg.src=IMGDIR+candidate.f;
  }

  document.getElementById('exit').classList.add('show');
  document.body.style.overflow='hidden';
}

function closeExit(){
  document.getElementById('exit').classList.remove('show');
  document.body.style.overflow='';
}

function submitExitForm(){
  var email=document.getElementById('exitEmail');
  if(!email||!email.value||!email.value.includes('@')){
    email.style.borderBottomColor='var(--sale)';
    email.focus();
    return;
  }
  /* ── On Shopify: replace this block with Klaviyo identify call ──
     klaviyo.push(['identify',{$email:email.value}]);
     klaviyo.push(['track','Signup Form Submitted',{source:'exit_popup'}]);
  ──────────────────────────────────────────────────────────────── */
  closeExit();
}




/* ── IYR rotating reviews ── */
(function(){
  var slides=document.querySelectorAll('#qcardReviews .qr-slide');
  var dotsWrap=document.getElementById('qrDots');
  if(!slides.length||!dotsWrap)return;
  var ci=0,dots=[];
  slides.forEach(function(_,i){
    var d=document.createElement('button');
    d.className='qr-dot'+(i===0?' active':'');
    d.setAttribute('aria-label','Review '+(i+1));
    d.onclick=function(){goQr(i)};
    dotsWrap.appendChild(d);
    dots.push(d);
  });
  function goQr(n){
    slides[ci].classList.remove('active');
    dots[ci].classList.remove('active');
    ci=(n+slides.length)%slides.length;
    slides[ci].classList.add('active');
    dots[ci].classList.add('active');
  }
  setInterval(function(){goQr(ci+1)},4000);
})();

/* ── Back to top progress ring ── */
(function(){
  var btn=document.getElementById('btt');
  var prog=document.getElementById('bttProg');
  var aplus=document.querySelector('.aplus');
  if(!btn||!prog||!aplus)return;
  var C=138; // circumference ~2*PI*22
  function update(){
    var aplusTop=aplus.getBoundingClientRect().top+window.scrollY;
    var show=window.scrollY>aplusTop;
    btn.classList.toggle('show',show);
    var pct=window.scrollY/(document.body.scrollHeight-window.innerHeight);
    prog.style.strokeDashoffset=C-(C*Math.min(1,Math.max(0,pct)));
  }
  window.addEventListener('scroll',update,{passive:true});
  update();
})();

/* ── Sticky buy bar: _42 FIX - REVERTED from "v124 ALWAYS ON" back to
   a scroll-based trigger, per explicit direction. Sticky bar now
   starts hidden - only appears once the main "Add to Basket" button
   (#mainAtc) scrolls out of the thumb-reachable zone (i.e. its own
   bottom edge leaves the viewport), same logic shape as the old v101
   trigger but keyed off the actual CTA button element (#mainAtc)
   rather than the price element, to match "once the main cta is
   visible... once it's out of the thumb zone the sticky CTA comes
   up" precisely. Old v124-always-on forced .add() calls removed (not
   deleted - see the commented block below), old v101 .price-based
   version also left commented, per the never-delete convention. ── */
(function(){
  var sticky=document.getElementById('stickybar');
  var ctaEl=document.getElementById('mainAtc');
  if(!sticky)return;

  function update(){
    if(ctaEl){
      var ctaGone=ctaEl.getBoundingClientRect().bottom<0;
      sticky.classList.toggle('show',ctaGone);
      if(__root)__root.classList.toggle('astra-sbv',ctaGone);
    }
  }
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',update,{passive:true});
  update();

  /* _41-and-earlier v124 ALWAYS ON, kept per never-delete convention:
  sticky.classList.add('show');
  document.body.classList.add('sb-visible');
  */

  /* v101 .price-based version, kept per never-delete convention:
  var priceEl=document.querySelector('.price');
  function updateOld(){
    if(priceEl){
      var priceGone=priceEl.getBoundingClientRect().bottom<0;
      sticky.classList.toggle('show',priceGone);
      document.body.classList.toggle('sb-visible',priceGone);
    }
  }
  window.addEventListener('scroll',updateOld,{passive:true});
  window.addEventListener('resize',updateOld,{passive:true});
  updateOld();
  */
})();

/* Sticky-card title word-boundary fit, ported from the reference design
   (final_version_v143_no-thumb.html) so the sticky bar's title truncates
   the same way there: to the last whole word that still fits, never a
   mid-word cut or an appended "...". Reset from the full stored title on
   every run (not the already-truncated text) since the bar can go from
   narrow mobile to wide desktop between runs. Runs on load and resize -
   .sb-name always has layout (the bar is hidden via transform, not
   display:none) so clientWidth is measurable even before the bar's first
   .show. */
(function(){
  function fitTitleWords(el){
    if(!el)return;
    if(el.dataset.full===undefined)el.dataset.full=el.textContent;
    var full=el.dataset.full;
    var words=full.split(' ');
    el.textContent=full;
    if(el.scrollWidth<=el.clientWidth)return;
    while(words.length>1&&el.scrollWidth>el.clientWidth){
      words.pop();
      el.textContent=words.join(' ');
    }
  }
  function fitAllTitles(){
    document.querySelectorAll('.sb-name').forEach(fitTitleWords);
  }
  window.addEventListener('load',fitAllTitles);
  window.addEventListener('resize',fitAllTitles);
  fitAllTitles();
})();

    /* v130: the coupon call that used to run here is gone - the offer row is
       server-rendered from the theme's offer settings (see astraSyncCouponFromBanner).
       v129:
    astraSyncCouponFromBanner();
    */

    astraWatchBnpl();

    /* expose inline-handler functions (craftGo self-assigns to window) */
    window.acc=typeof acc==='function'?acc:window.acc;window.selectSwatch=typeof selectSwatch==='function'?selectSwatch:window.selectSwatch;window.openCompareModal=typeof openCompareModal==='function'?openCompareModal:window.openCompareModal;window.closeCompareModal=typeof closeCompareModal==='function'?closeCompareModal:window.closeCompareModal;window.openCareModal=typeof openCareModal==='function'?openCareModal:window.openCareModal;window.closeCareModal=typeof closeCareModal==='function'?closeCareModal:window.closeCareModal;window.openUgc=typeof openUgc==='function'?openUgc:window.openUgc;window.closeUgc=typeof closeUgc==='function'?closeUgc:window.closeUgc;window.openTrust=typeof openTrust==='function'?openTrust:window.openTrust;window.closeTrust=typeof closeTrust==='function'?closeTrust:window.closeTrust;window.switchCmpTab=typeof switchCmpTab==='function'?switchCmpTab:window.switchCmpTab;window.toggleCouponAccordion=typeof toggleCouponAccordion==='function'?toggleCouponAccordion:window.toggleCouponAccordion;window.togglePayWidgets=typeof togglePayWidgets==='function'?togglePayWidgets:window.togglePayWidgets;window.copyCode=typeof copyCode==='function'?copyCode:window.copyCode;window.fbtCalc=typeof fbtCalc==='function'?fbtCalc:window.fbtCalc;window.lbNav=typeof lbNav==='function'?lbNav:window.lbNav;window.closeLightbox=typeof closeLightbox==='function'?closeLightbox:window.closeLightbox;window.lbZoomStep=typeof lbZoomStep==='function'?lbZoomStep:window.lbZoomStep;window.lbZoomReset=typeof lbZoomReset==='function'?lbZoomReset:window.lbZoomReset;window.clbNav=typeof clbNav==='function'?clbNav:window.clbNav;window.closeCardLightbox=typeof closeCardLightbox==='function'?closeCardLightbox:window.closeCardLightbox;window.openCardLightbox=typeof openCardLightbox==='function'?openCardLightbox:window.openCardLightbox;window.qty=typeof qty==='function'?qty:window.qty;window.estDelivery=typeof estDelivery==='function'?estDelivery:window.estDelivery;
  }
  if(document.readyState!=='loading')astra();
  else document.addEventListener('DOMContentLoaded',astra);
  document.addEventListener('shopify:section:load',astra);
})();
